<template>
  <div v-if="dataLoading" class="p-2">
    <div class="results-list-card p-3">
      <b-row class="align-items-center">
        <b-col v-for="i in 4" :key="i" md="2" class="mb-1">
          <div class="skeleton-line w-50 mb-1"></div>
          <div
            class="skeleton-line w-100"
            style="height: 40px; border-radius: 8px"
          ></div>
        </b-col>
        <b-col md="4" class="d-flex align-items-end justify-content-end mb-1">
          <div
            class="skeleton-line mr-1"
            style="width: 100px; height: 40px; border-radius: 8px"
          ></div>
          <div
            class="skeleton-line"
            style="width: 40px; height: 40px; border-radius: 8px"
          ></div>
        </b-col>
      </b-row>
    </div>
  </div>
  <div v-else>
    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          {{ $t(sidebarTitle) }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Obtained Marks *')"
              :invalid-feedback="$t('marks is required.')"
              ref="marks"
            >
              <b-form-input
                id="mc-first-name"
                :placeholder="$t('Enter obtained marks here')"
                ref="marks"
                v-model="marksObj.obtained_marks"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1 fullWidth"
              @click="Add()"
              :disabled="request"
              block
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-if="request == false"> {{ $t(sidebarButton) }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility4"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Publish Result") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility4 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('Publish From')"
              :invalid-feedback="$t('Date is required')"
              ref="pub_from"
            >
              <flat-pickr
                :config="config2"
                ref="pub_from"
                v-model="pubObj.dtFrom"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Publish Till')"
              :invalid-feedback="$t('Date is required')"
              ref="pub_till"
            >
              <flat-pickr
                :config="config2"
                ref="pub_till"
                v-model="pubObj.dtTo"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="publish()"
              :disabled="publishing"
              block
            >
              <b-spinner v-if="publishing" small type="grow" />
              <span v-else>
                {{ $t(isPublish ? "Unpublish" : "Publish") }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility2"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Fee Reward") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility2 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Class')"
              :invalid-feedback="$t('Class is required')"
              ref="reward_class"
            >
              <v-select
                v-model="rewardObj.clsID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                input-id="id"
                ref="reward_class"
                @input="FillRewardSec()"
                @search:blur="getFee()"
                :placeholder="$t('Select class')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Section')"
              :invalid-feedback="$t('Section is required')"
              ref="reward_sec"
            >
              <v-select
                ref="reward_sec"
                v-model="rewardObj.secIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="rewardSections"
                :reduce="(val) => val.id"
                label="section"
                :clearable="false"
                :placeholder="$t('Select section')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              :label="$t('Class Statndard Fee')"
              :invalid-feedback="$t('Standard fee is required.')"
              ref="fee"
            >
              <b-form-input
                :disabled="true"
                type="number"
                :placeholder="$t('Enter class standard fee')"
                ref="fee"
                v-model="rewardObj.fee"
                @input="CheckNum()"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1"
              @click="ApplyDiscount()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else> {{ $t("Apply Discount") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility3"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Result Settings") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility3 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12" v-if="reportDomain == 'myskoolmerittoexcel'">
            <b-form-group
              :label="$t('Absent Marks Deduction')"
              :invalid-feedback="$t('marks is required.')"
              ref="marks"
            >
              <b-form-input
                id="mc-first-name"
                :placeholder="$t('Enter absent marks deduction here')"
                ref="marks"
                v-model="settObj.absentMarks"
              />
            </b-form-group>
          </b-col>
          <!-- separate print date for iota -->
          <b-col md="12" v-if="isSeparatePrintDate">
            <b-form-group
              :label="$t('Print Date')"
              :invalid-feedback="$t('Print Date is required')"
              ref="print_date"
            >
              <flat-pickr
                :config="config2"
                v-model="settObj.printDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <!-- for others -->
          <b-col md="12" v-else>
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="date"
            >
              <flat-pickr
                :config="config"
                ref="date"
                v-model="settObj.rangeDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="lockObj && lockObj.valueBool">
            <b-form-group
              :label="$t('Auto Lock after (days)')"
              :invalid-feedback="$t('Day is required.')"
              ref="lock_days"
            >
              <b-button
                v-for="n in 10"
                :key="n"
                :variant="
                  lockObj.valueNumber == n ? 'primary' : 'outline-primary'
                "
                class="mr-50 mb-50"
                @click="lockObj.valueNumber = n"
              >
                {{ n }}
              </b-button>
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="formatObj">
            <b-form-group
              :label="$t('Result Format')"
              :invalid-feedback="$t('Result Format is required.')"
              ref="res_form"
            >
              <v-select
                append-to-body
                v-model="formatObj.value"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="formatOptions"
                :reduce="(val) => val.value"
                label="text"
                :clearable="false"
                :placeholder="$t('Select result format')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="termDate">
            <b-form-group
              :label="$t('Exam Date')"
              :invalid-feedback="$t('Exam Date is required.')"
              ref="exam_date"
            >
              <b-form-input
                :placeholder="$t('Enter date')"
                v-model="termDate.value"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="titleObj">
            <b-form-group
              :label="$t('Exam Title')"
              :invalid-feedback="$t('Exam Title is required')"
              ref="exam_title"
            >
              <b-form-input
                :placeholder="$t('Enter exam title')"
                v-model="titleObj.value"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="logoObj"
            md="12"
            class="d-flex align-items-center justify-content-between mb-1"
          >
            <h4 class="mb-0 mr-1">{{ $t("Show Logo") }}</h4>
            <b-form-checkbox v-model="logoObj.valueBool" switch />
          </b-col>

          <b-col
            v-if="headerObj"
            md="12"
            class="d-flex align-items-center justify-content-between mb-1"
          >
            <h4 class="mb-0 mr-1">{{ $t("Show Header") }}</h4>
            <b-form-checkbox v-model="headerObj.valueBool" switch />
          </b-col>

          <b-col
            v-if="footerObj"
            md="12"
            class="d-flex align-items-center justify-content-between mb-1"
          >
            <h4 class="mb-0 mr-1">{{ $t("Show Footer") }}</h4>
            <b-form-checkbox v-model="footerObj.valueBool" switch />
          </b-col>

          <b-col
            v-if="stampObj"
            md="12"
            class="d-flex align-items-center justify-content-between"
          >
            <h4 class="mb-0 mr-1">{{ $t("Show Stamp") }}</h4>
            <b-form-checkbox v-model="stampObj.valueBool" switch />
          </b-col>
          <b-col md="12" v-if="stampObj && stampObj.valueBool">
            <b-form-group
              :label="$t('Stamp Image')"
              :invalid-feedback="$t('Stamp Image is required')"
              required
              ref="stamp"
              class="mb-50"
            >
              <b-spinner
                v-if="stLoading"
                type="grow"
                :label="$t('Loading') + '...'"
                variant="primary"
                class="m-5"
              />
              <b-img
                v-else-if="!stampObj.value"
                ref="previewEl"
                src="https://cdn.cloudious.net/file-1678189226453-406060527.png"
                @click="$refs.stampImg.click()"
                style="border-radius: 10px"
                height="120px"
                width="120px"
              />
              <div v-else class="d-flex align-items-center">
                <b-img
                  :src="stampObj.value"
                  style="border-radius: 10px"
                  height="120px"
                  width="120px"
                />
                <feather-icon
                  icon="Trash2Icon"
                  size="22"
                  class="text-danger cursor-pointer ml-1"
                  @click="removeStamp()"
                />
              </div>
              <input
                type="file"
                id="stampImg"
                hidden
                ref="stampImg"
                @change="addStamp()"
                accept="image/*"
              />
            </b-form-group>
          </b-col>

          <template v-if="headerImageObj">
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-between mt-1"
            >
              <h4 class="mb-0 mr-1">{{ $t("Header Image") }}</h4>
              <feather-icon
                v-if="headerImageObj.value"
                icon="Trash2Icon"
                size="22"
                class="text-danger cursor-pointer ml-1"
                @click="removeHeaderImg()"
              />
            </b-col>
            <b-col md="12" class="mt-1">
              <b-form-group
                :invalid-feedback="$t('Header Image is required')"
                ref="header_image"
                class="mb-50"
              >
                <b-spinner
                  v-if="imgLoading"
                  type="grow"
                  :label="$t('Loading') + '...'"
                  variant="primary"
                  class="m-5"
                />
                <b-img
                  v-else-if="!headerImageObj.value"
                  ref="previewEl"
                  src="https://cdn.cloudious.net/file-1791451009409-436325750.png"
                  @click="$refs.headerImg.click()"
                  style="width: 100%; height: 180px; border-radius: 10px"
                />
                <div v-else class="d-flex align-items-center">
                  <b-img
                    :src="headerImageObj.value"
                    style="
                      width: 100%;
                      height: 180px;
                      object-fit: contain;
                      border-radius: 10px;
                    "
                  />
                </div>
                <input
                  type="file"
                  id="headerImg"
                  hidden
                  ref="headerImg"
                  @change="addHeaderImg()"
                  accept="image/*"
                />
              </b-form-group>
            </b-col>
          </template>

          <template v-if="footerImageObj">
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-between"
            >
              <h4 class="mb-0 mr-1">{{ $t("Footer Image") }}</h4>
              <feather-icon
                v-if="footerImageObj.value"
                icon="Trash2Icon"
                size="22"
                class="text-danger cursor-pointer ml-1"
                @click="removeFooterImg()"
              />
            </b-col>
            <b-col md="12" class="mt-1">
              <b-form-group
                :invalid-feedback="$t('Footer Image is required')"
                ref="footer_image"
                class="mb-50"
              >
                <b-spinner
                  v-if="footerImgLoading"
                  type="grow"
                  :label="$t('Loading') + '...'"
                  variant="primary"
                  class="m-5"
                />
                <b-img
                  v-else-if="!footerImageObj.value"
                  ref="previewElFooter"
                  src="https://cdn.cloudious.net/file-1791451009409-436325750.png"
                  @click="$refs.footerImg.click()"
                  style="width: 100%; height: 180px; border-radius: 10px"
                />
                <div v-else class="d-flex align-items-center">
                  <b-img
                    :src="footerImageObj.value"
                    style="
                      width: 100%;
                      height: 180px;
                      object-fit: contain;
                      border-radius: 10px;
                    "
                  />
                </div>
                <input
                  type="file"
                  id="footerImg"
                  hidden
                  ref="footerImg"
                  @change="addFooterImg()"
                  accept="image/*"
                />
              </b-form-group>
            </b-col>
          </template>

          <b-col
            v-if="promotedObj"
            md="12"
            class="d-flex align-items-center justify-content-between my-50"
          >
            <h4 class="mb-0 mr-1">{{ $t("Show Promoted") }}</h4>
            <b-form-checkbox v-model="promotedObj.valueBool" switch />
          </b-col>

          <b-col
            v-if="courseObj"
            md="12"
            class="d-flex align-items-center justify-content-between mb-50"
          >
            <h4 class="mb-0 mr-1">{{ $t("Course Marks") }}</h4>
            <b-form-checkbox v-model="courseObj.valueBool" switch />
          </b-col>
          <b-col md="12" v-if="courseObj && courseObj.valueBool">
            <!-- label="Exam Type" -->
            <b-form-group
              :invalid-feedback="$t('Exam Type is required.')"
              ref="c_exam"
            >
              <v-select
                v-model="courseObj.valueNumber"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="examType"
                :reduce="(val) => val.id"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select exam type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              @click="saveMax()"
              :disabled="saving"
              block
            >
              <b-spinner v-if="saving" small type="grow" />
              <span v-else> {{ $t("Save") }} </span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility5"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Average / Grace Marks") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility5 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Class')"
              :invalid-feedback="$t('Class is required')"
              ref="grace_class"
            >
              <v-select
                v-model="graceObj.classID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="classesOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                input-id="id"
                ref="grace_class"
                @input="FillGraceSec()"
                :placeholder="$t('Select class')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Section')"
              :invalid-feedback="$t('Section is required')"
              ref="grace_sec"
            >
              <v-select
                ref="grace_sec"
                v-model="graceObj.sectionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="graceSections"
                :reduce="(val) => val.id"
                label="section"
                :clearable="false"
                :placeholder="$t('Select section')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Session')"
              :invalid-feedback="$t('Session is required.')"
              ref="grace_session"
            >
              <v-select
                ref="grace_session"
                v-model="graceObj.sessionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sessions"
                :reduce="(val) => val.id"
                label="session"
                :clearable="false"
                :placeholder="$t('Select session')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Update Marks For')"
              :invalid-feedback="$t('Exam type is required.')"
              ref="grace_examType"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                ref="grace_examType"
                v-model="graceObj.examIDs"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="examType"
                :reduce="(val) => val.id"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select exam type to update')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Based On')"
              :invalid-feedback="$t('Based On is required.')"
              ref="based"
            >
              <v-select
                ref="based"
                v-model="graceObj.basedOn"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="examType"
                :reduce="(val) => val.id"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select exam type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Type')"
              :invalid-feedback="$t('Type is required')"
              ref="type"
            >
              <v-select
                ref="type"
                v-model="graceObj.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="typeOptions"
                :reduce="(val) => val.value"
                label="text"
                :clearable="false"
                :placeholder="$t('Select')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              class="mr-1"
              @click="ApplyGrace()"
              :disabled="gracing"
              block
            >
              <b-spinner v-if="gracing" small type="grow" />
              <span v-else>{{ $t("Update") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility6"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Result Summary") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility6 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="mt-1">
          <b-col md="12">
            <b-form-group
              :label="$t('Classes')"
              :invalid-feedback="$t('Classes is required')"
              ref="summary_class"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="summaryObj.clsID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ id: 0, name: 'All Classes' }, ...classesOptions]"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                @input="setSummaryClasses()"
                :placeholder="$t('Select class')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="singleSummary.includes(reportDomain)">
            <b-form-group
              :label="$t('Exam Type')"
              :invalid-feedback="$t('Exam type is required.')"
              ref="summary_examType_single"
            >
              <v-select
                v-model="summaryObj.singleExamID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="examType"
                :reduce="(val) => val.id"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select exam type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" v-else>
            <b-form-group
              :label="$t('Exam Type')"
              :invalid-feedback="$t('Exam type is required.')"
              ref="summary_examType"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="summaryObj.examTypeID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="examType"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select exam type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Session')"
              :invalid-feedback="$t('Session is required.')"
              ref="summary_session"
            >
              <v-select
                ref="summary_session"
                v-model="summaryObj.sessionID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="sessions"
                :reduce="(val) => val.id"
                label="session"
                :clearable="false"
                :placeholder="$t('Select session')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mt-1">
            <b-button variant="success" @click="showSummary()" block>
              <span>{{ $t("Show") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <b-card class="results-list-card">
      <b-row align-h="start" class="text-left align-items-center mt-1">
        <b-col md="2">
          <b-form-group
            :label="$t('Class')"
            :invalid-feedback="$t('Class is required.')"
            ref="class"
            class="filter-group-custom"
          >
            <v-select
              append-to-body
              v-model="myObj.clsID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="classesOptions"
              :clearable="false"
              label="name"
              :reduce="(val) => val.id"
              input-id="id"
              ref="class"
              @input="FillSections()"
              :placeholder="$t('Select class')"
              @search:blur="checkLock()"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            :label="$t('Section')"
            :invalid-feedback="$t('Section is required.')"
            ref="sec"
            class="filter-group-custom"
          >
            <v-select
              append-to-body
              ref="sec"
              v-model="myObj.sec"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="currentSections"
              :reduce="(val) => val.id"
              label="section"
              :clearable="false"
              :placeholder="$t('Select section')"
              @input="checkLock()"
            />
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group
            :label="$t('Exam Type')"
            :invalid-feedback="$t('Exam Type is required.')"
            ref="examType"
            class="filter-group-custom"
          >
            <v-select
              append-to-body
              multiple
              :closeOnSelect="false"
              ref="examType"
              v-model="myObj.examTypeID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="examType"
              :reduce="(val) => val.id"
              label="examType"
              :clearable="false"
              :placeholder="$t('Select exam type')"
              @input="checkLock()"
            />
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group
            :label="$t('Session')"
            :invalid-feedback="$t('Session is required.')"
            ref="session"
            class="filter-group-custom"
          >
            <v-select
              append-to-body
              ref="session"
              v-model="myObj.sessionID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="sessions"
              :reduce="(val) => val.id"
              label="session"
              :clearable="false"
              :placeholder="$t('Select session')"
              @input="checkLock()"
            />
          </b-form-group>
        </b-col>

        <b-col md="3" v-if="isDatewise">
          <b-form-group
            :label="$t('Date Range')"
            :invalid-feedback="$t('Date is required')"
          >
            <b-input-group>
              <flat-pickr
                :config="config"
                v-model="settObj.rangeDate"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
              <b-input-group-append
                is-text
                @click.stop="settObj.rangeDate = null"
                v-b-tooltip.hover.top
                :title="$t('Clear')"
              >
                <feather-icon class="cursor-pointer" size="16" icon="XIcon" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="" class="d-flex align-items-end justify-content-end">
          <div
            class="d-flex flex-column align-items-end"
            style="gap: 8px; margin-bottom: 4px"
          >
            <!-- Row 1: Primary Management -->
            <div class="d-flex align-items-center" style="gap: 8px">
              <!-- Show -->
              <b-button
                class="filter-action-btn btn-show-premium"
                @click="show()"
                :disabled="iShow || resultJobVisible"
              >
                <b-spinner v-if="this.iShow" small type="grow" class="mr-50" />
                <feather-icon
                  v-if="!this.iShow"
                  icon="SearchIcon"
                  size="18"
                  class="mr-50"
                />
                <span>{{ $t("Show") }}</span>
              </b-button>

              <!-- Print -->
              <b-dropdown
                v-if="reportDomain == 'myskoolhpgs'"
                class="filter-action-btn-dropdown"
                toggle-class="filter-action-btn btn-action-outline-premium"
                variant="outline-primary"
                no-caret
                right
                no-flip
                :disabled="iPrint || resultJobVisible"
              >
                <template #button-content>
                  <b-spinner v-if="iPrint" small class="mr-50" />
                  <feather-icon
                    v-else
                    icon="PrinterIcon"
                    size="16"
                    class="mr-50"
                  />
                  <span>{{ $t("Print") }}</span>
                  <span v-if="selectedIDs.length > 0" class="ml-25"
                    >({{ selectedIDs.length }})</span
                  >
                </template>
                <b-dropdown-item @click="print('', '')">
                  <feather-icon icon="PrinterIcon" size="14" class="mr-50" />
                  {{ $t("Print") }}
                </b-dropdown-item>
                <b-dropdown-item @click="print('', 'tabulation')">
                  <feather-icon icon="FileTextIcon" size="14" class="mr-50" />
                  {{ $t("Qualitative Review") }}
                </b-dropdown-item>
              </b-dropdown>

              <b-button
                v-else
                class="filter-action-btn btn-action-outline-premium"
                style="width: auto; padding: 0 12px !important"
                v-b-tooltip.hover.top
                :disabled="iPrint || resultJobVisible"
                @click="print('')"
              >
                <b-spinner v-if="iPrint" small class="mr-50" />
                <feather-icon
                  v-else
                  icon="PrinterIcon"
                  size="16"
                  class="mr-50"
                />
                <span>{{ $t("Print") }}</span>
                <span v-if="selectedIDs.length > 0" class="ml-25"
                  >({{ selectedIDs.length }})</span
                >
              </b-button>

              <!-- Publish -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Publish')"
                :disabled="loadingStatus"
                @click="CheckStatus()"
              >
                <b-spinner v-if="loadingStatus" small />
                <feather-icon v-else icon="GlobeIcon" size="18" />
              </b-button>

              <!-- Lock -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="isLock ? $t('Unlock') : $t('Lock')"
                :disabled="locking"
                @click="lock()"
              >
                <b-spinner v-if="locking" small />
                <feather-icon
                  v-else
                  :icon="isLock ? 'LockIcon' : 'UnlockIcon'"
                  size="18"
                />
              </b-button>
            </div>

            <!-- Row 2: Secondary Tools -->
            <div class="d-flex align-items-center" style="gap: 8px">
              <!-- WhatsApp -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Send WhatsApp')"
                :disabled="sending"
                @click="sendMessage()"
              >
                <b-spinner v-if="sending" small />
                <div class="position-relative d-flex align-items-center">
                  <feather-icon icon="MessageCircleIcon" size="18" />
                  <b-badge
                    v-if="selectedIDs.length > 0"
                    variant="primary"
                    pill
                    class="position-absolute"
                    style="top: -12px; right: -12px; font-size: 0.65rem"
                  >
                    {{ selectedIDs.length }}
                  </b-badge>
                </div>
              </b-button>

              <!-- Reward -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Fee Reward')"
                @click="openSettings()"
              >
                <feather-icon icon="DollarSignIcon" size="18" />
              </b-button>

              <!-- Settings -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Settings')"
                @click="openMax()"
              >
                <feather-icon icon="SettingsIcon" size="18" />
              </b-button>

              <!-- Export -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Export')"
                :disabled="exporting"
                @click="exportData()"
              >
                <b-spinner v-if="exporting" small />
                <feather-icon v-else icon="DownloadIcon" size="18" />
              </b-button>

              <!-- Grace -->
              <b-button
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Average / Grace Marks')"
                @click="openGrace()"
              >
                <feather-icon icon="AwardIcon" size="18" />
              </b-button>

              <!-- Approve (Conditional) -->
              <template v-if="approveObj && approveObj.valueBool">
                <b-button
                  v-if="isApproved"
                  class="filter-action-btn btn-action-outline-premium"
                  style="
                    border-color: #ea5455 !important;
                    color: #ea5455 !important;
                  "
                  v-b-tooltip.hover.top
                  :title="$t('Undo Approval')"
                  :disabled="approving"
                  @click="approveRes(false)"
                >
                  <b-spinner v-if="approving" small />
                  <feather-icon v-else icon="RotateCcwIcon" size="18" />
                </b-button>
                <b-button
                  v-else
                  class="filter-action-btn btn-action-outline-premium"
                  style="
                    border-color: #28c76f !important;
                    color: #28c76f !important;
                  "
                  v-b-tooltip.hover.top
                  :title="$t('Approve Results')"
                  :disabled="approving"
                  @click="approveRes(true)"
                >
                  <b-spinner v-if="approving" small />
                  <feather-icon v-else icon="CheckCircleIcon" size="18" />
                </b-button>
              </template>

              <!-- Attendance (Conditional) -->
              <b-button
                v-if="reportDomain == 'myskoolmakjauhar'"
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Attendance')"
                @click="openAttendance()"
              >
                <feather-icon icon="UserCheckIcon" size="18" />
              </b-button>

              <!-- Summary (Conditional) -->
              <b-button
                v-if="
                  [
                    'myskoolconceptthatta',
                    'myskoolperfectthatta',
                    'myskoolhhpublic',
                  ].includes(reportDomain)
                "
                class="filter-action-btn btn-action-outline-premium"
                v-b-tooltip.hover.top
                :title="$t('Result Summary')"
                @click="openSummary()"
              >
                <feather-icon icon="BarChart2Icon" size="18" />
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>

    <b-card
      v-if="
        showGrid &&
        otherReportsObj &&
        otherReportsObj.valueBool &&
        items.length > 0
      "
      class="results-list-card mt-2"
    >
      <b-row>
        <b-col md="3">
          <b-form-group
            :label="$t('Report')"
            :invalid-feedback="$t('Report is required.')"
          >
            <v-select
              append-to-body
              v-model="reportFilter.type"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :disabled="sheetLoading"
              :options="reportOptions"
              :reduce="(opt) => opt.value"
              label="text"
              :placeholder="$t('Select report type')"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            :label="$t('Subject')"
            :invalid-feedback="$t('Subject is required.')"
          >
            <v-select
              append-to-body
              v-model="reportFilter.subjectID"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :disabled="subLoading || sheetLoading"
              :options="[{ id: 0, subject: 'All Subjects' }, ...subjectList]"
              :reduce="(opt) => opt.id"
              label="subject"
              :placeholder="$t('Select subject')"
            />
          </b-form-group>
        </b-col>
        <!-- <b-col md="12">
          <b-form-checkbox v-model="reportFilter.withU"
            ><span class="mr-1">With U</span>
          </b-form-checkbox>
        </b-col> -->
        <b-col>
          <b-button
            variant="success mt-2"
            class="btn-icon"
            :disabled="sheetLoading || gridLoading || resultJobVisible"
            @click="dataSheet(reportFilter.type)"
          >
            <b-spinner v-if="sheetLoading" small type="grow" class="mr-50" />
            <span>{{ $t("Generate") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card v-if="showGrid" class="results-list-card mt-2">
      <div class="table-header pb-2">
        <div
          class="d-flex align-items-center"
          style="gap: 8px; flex-wrap: nowrap"
        >
          <!-- Left Side: Search and Clear -->
          <div
            class="d-flex align-items-center flex-shrink-0 mr-2"
            style="min-width: 300px; max-width: 420px; flex: 0 0 360px"
          >
            <b-button
              v-if="selectedIDs.length > 0"
              variant="outline-secondary"
              class="mr-1 flex-shrink-0 d-flex align-items-center justify-content-center clear-btn"
              v-b-tooltip.hover.top
              :title="$t('Clear Selection')"
              @click="clear()"
            >
              <feather-icon icon="XIcon" size="18" />
            </b-button>
            <b-input-group class="search-group" style="flex: 1">
              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search students...')"
                class="filter-control"
              />
            </b-input-group>
          </div>

          <!-- Stats pills - scrollable row on mobile -->
          <div
            class="stats-pill-row d-flex align-items-center flex-grow-1"
            style="overflow-x: auto; gap: 8px; padding-bottom: 2px"
          >
            <template v-if="items.length > 0">
              <div class="stat-badge">
                <span class="stat-num">{{ stats.total }}</span>
                <span class="stat-sep">·</span>
                <span class="stat-label">Total</span>
              </div>
              <div class="stat-badge stat-passed">
                <span class="stat-num">{{ stats.passed }}</span>
                <span class="stat-sep">·</span>
                <span class="stat-label">Passed</span>
              </div>
              <div class="stat-badge stat-failed">
                <span class="stat-num">{{ stats.failed }}</span>
                <span class="stat-sep">·</span>
                <span class="stat-label">Failed</span>
              </div>
              <div
                v-for="grade in stats.grades"
                :key="grade.name"
                class="stat-badge stat-grade"
              >
                <span class="stat-num">{{ grade.count }}</span>
                <span class="stat-sep">·</span>
                <span class="stat-label">Grade {{ grade.name }}</span>
              </div>
            </template>
            <template v-else-if="gridLoading">
              <div
                v-for="i in 4"
                :key="'stat-skel-' + i"
                class="skeleton-line"
                style="
                  min-width: 100px;
                  height: 32px;
                  border-radius: 20px;
                  flex-shrink: 0;
                "
              ></div>
            </template>
          </div>

          <!-- DataSheet button on far right -->
          <template v-if="sheetObj && sheetObj.valueBool">
            <b-dropdown
              v-if="reportDomain == 'myskoolaba'"
              button-class="btn-icon flex-shrink-0"
              split
              variant="success"
              right
              :disabled="sheetLoading || gridLoading || resultJobVisible"
              @click="dataSheet()"
            >
              <template #button-content>
                <b-spinner v-if="sheetLoading" small type="grow" />
                <span v-else>{{ $t("DataSheet") }}</span>
              </template>
              <b-dropdown-item @click="dataSheet('summary')">{{
                $t("Grade Summary")
              }}</b-dropdown-item>
              <b-dropdown-item @click="dataSheet('stdDevelopment')">{{
                $t("Student Development")
              }}</b-dropdown-item>
              <b-dropdown-item @click="dataSheet('teacherRemarks')">{{
                $t("Class Teacher Remarks")
              }}</b-dropdown-item>
            </b-dropdown>
            <b-button
              v-else
              variant="success"
              class="btn-icon flex-shrink-0"
              :disabled="sheetLoading || gridLoading || resultJobVisible"
              @click="dataSheet()"
            >
              <b-spinner v-if="sheetLoading" small type="grow" />
              <span v-else>{{ $t("DataSheet") }}</span>
            </b-button>
          </template>
        </div>
      </div>

      <div class="table-scroll-container">
        <div class="table-wrapper">
          <b-table
            ref="selectableTable"
            :items="filters"
            :fields="fields"
            show-empty
            :busy="gridLoading"
            :responsive="false"
            sticky-header="65vh"
            hover
            small
            class="results-modern-table"
            @row-clicked="onRowSelect"
          >
            <template #head()="scope">
              <div>
                {{ $t(scope.label) }}
              </div>
            </template>
            <template #table-busy>
              <div class="skeleton-container w-100">
                <div
                  v-for="n in 6"
                  :key="'skeleton-' + n"
                  class="skeleton-row-item"
                >
                  <div
                    class="skeleton-item-wrapper d-flex align-items-center px-3"
                  >
                    <!-- Left Side: Avatar + Name -->
                    <div
                      class="d-flex align-items-center"
                      style="width: 300px; flex-shrink: 0"
                    >
                      <div
                        class="skeleton-line mr-2"
                        style="
                          width: 48px;
                          height: 48px;
                          border-radius: 14px;
                          flex-shrink: 0;
                        "
                      ></div>
                      <div>
                        <div
                          class="skeleton-line mb-50"
                          style="width: 80px; height: 12px; border-radius: 4px"
                        ></div>
                        <div
                          class="skeleton-line"
                          style="width: 180px; height: 24px; border-radius: 8px"
                        ></div>
                      </div>
                    </div>

                    <!-- Middle: Metric Boxes distributed across columns -->
                    <div
                      class="d-none d-md-flex flex-grow-1 align-items-center justify-content-around px-4"
                    >
                      <div
                        v-for="i in 5"
                        :key="'metric-' + i"
                        class="skeleton-line"
                        style="width: 80px; height: 32px; border-radius: 8px"
                      ></div>
                    </div>

                    <!-- Right Side: Action Box -->
                    <div
                      class="d-none d-md-block"
                      style="width: 100px; flex-shrink: 0; text-align: right"
                    >
                      <div
                        class="skeleton-line ml-auto"
                        style="width: 40px; height: 40px; border-radius: 12px"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template #head(index)="data">
              <div>
                <b-form-checkbox
                  inline
                  :checked="
                    selectedIDs.length > 0 && selectedIDs.length == items.length
                  "
                  :disabled="gridLoading || sheetLoading"
                  @change="(e) => setSelectAll(e)"
                >
                  <span class="font-small-2">{{ data.label }}</span>
                </b-form-checkbox>
              </div>
            </template>

            <template #cell(index)="data">
              <b-form-checkbox
                inline
                :checked="selectedIDs.some((id) => id == data.item.sID)"
                :disabled="gridLoading || sheetLoading"
                @change="(e) => setSelected(e, data.item.sID)"
              >
                <b-badge variant="light-primary">
                  {{ items.indexOf(data.item) + 1 }}
                </b-badge>
              </b-form-checkbox>
            </template>

            <template #cell(grNo)="data">
              <b-badge variant="light-primary">
                {{ data.item.grNo }}
              </b-badge>
            </template>
            <template #cell(name)="data">
              <b-media vertical-align="center" class="name-media">
                <template #aside>
                  <b-avatar
                    size="42"
                    :src="pictureMap[String(data.item.sID)] || ''"
                    :text="
                      !pictureMap[String(data.item.sID)]
                        ? getInitials(data.item.name)
                        : ''
                    "
                    variant="light-primary"
                    class="avatar-shadow"
                  />
                </template>
                <div class="name-content">
                  <div class="student-subtitle">STUDENT</div>
                  <div class="font-weight-bold text-nowrap name-text">
                    {{ data.item.name }}
                  </div>
                  <div class="father-name-text">
                    F/N: {{ data.item.father_name }}
                  </div>
                  <div
                    v-if="getDues(data.item.sID) > 0"
                    class="dues-text font-weight-bolder"
                  >
                    <feather-icon
                      icon="AlertCircleIcon"
                      size="11"
                      class="mr-25"
                    />
                    {{ $t("Dues") }}: {{ getDues(data.item.sID) }}
                  </div>
                </div>
              </b-media>
            </template>
            <template #cell(totalMarks)="data">
              <b-badge variant="light-primary">
                {{ data.item.totalMarks }}
              </b-badge>
            </template>
            <template #cell(obtainedMarks)="data">
              <div class="metric-chip marks-chip">
                <feather-icon icon="FileTextIcon" size="11" class="mr-25" />
                <span class="font-weight-bold"
                  >{{ data.item.obtainedMarks }} /
                  {{ data.item.totalMarks }}</span
                >
              </div>
            </template>
            <template #cell(percentage)="data">
              <div class="metric-chip percentage-chip">
                <feather-icon icon="BarChart2Icon" size="11" class="mr-25" />
                <span class="font-weight-bold"
                  >{{ data.item.percentage }}%</span
                >
              </div>
            </template>

            <template #cell(rank)="data">
              <div
                :class="[
                  'metric-chip rank-chip',
                  data.item.rank == '1st' ||
                  data.item.rank == '2nd' ||
                  data.item.rank == '3rd'
                    ? 'rank-top'
                    : 'rank-normal',
                ]"
              >
                <feather-icon icon="AwardIcon" size="11" class="mr-25" />
                <span class="font-weight-bold">{{ data.item.rank }}</span>
              </div>
            </template>

            <template #cell(grade)="data">
              <div v-if="data.item.grade" class="metric-chip grade-chip">
                <feather-icon icon="StarIcon" size="11" class="mr-25" />
                <span class="font-weight-bold">{{ data.item.grade }}</span>
              </div>
            </template>
            <template #cell(result)="data">
              <b-badge
                pill
                :variant="
                  data.item.result == 'PASSED'
                    ? 'light-success'
                    : 'light-danger'
                "
                class="result-status-badge"
              >
                <feather-icon
                  :icon="data.item.result == 'PASSED' ? 'CheckIcon' : 'XIcon'"
                  size="12"
                  class="mr-25"
                />
                {{ data.item.result }}
              </b-badge>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex align-items-center" style="gap: 6px">
                <b-button
                  v-ripple.400="'rgba(124, 93, 250, 0.15)'"
                  variant="outline-primary"
                  class="print-action-btn"
                  v-b-tooltip.hover.top
                  :title="$t('Print')"
                  :disabled="iPrint && current == data.item.sID"
                  @click.stop="printSingle(data.item.sID)"
                >
                  <b-spinner
                    v-if="iPrint && current == data.item.sID"
                    small
                    style="color: #7c5dfa"
                  />
                  <feather-icon v-else icon="PrinterIcon" size="17" />
                </b-button>
                <b-button
                  v-if="reportDomain == 'myskoolelixir'"
                  variant="outline-primary"
                  class="print-action-btn"
                  v-b-tooltip.hover.top
                  :title="$t('Export Result')"
                  @click.stop="expResult(data.item.sID)"
                  :disabled="exportingRes"
                >
                  <b-spinner
                    v-if="exportingRes && currentExp == data.item.sID"
                    small
                    style="color: #7c5dfa"
                  />
                  <feather-icon v-else icon="DownloadIcon" size="17" />
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
    <b-card class="mt-2" v-if="showAtt">
      <b-row>
        <b-col md="12">
          <h3>{{ currentExam }} ({{ currentSession }})</h3>
        </b-col>
        <!-- Search -->
        <b-col cols="12" md="12">
          <div class="d-flex align-items-center justify-content-start">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-secondary"
              class="btn-icon mr-50"
              @click="Back()"
            >
              <feather-icon icon="ArrowLeftIcon" />
            </b-button>

            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-50"
              :placeholder="$t('Search') + '...'"
            />
            <b-form-group
              :label="$t('Total Days')"
              :invalid-feedback="$t('Total Days is required.')"
              ref="total"
            >
              <b-form-input
                id="mc-first-name"
                :placeholder="$t('Enter total')"
                ref="total"
                type="number"
                v-model="attData.totalDays"
                @keyup.enter="firstFocus()"
              />
            </b-form-group>
            <b-form-group
              :label="$t('Date')"
              :invalid-feedback="$t('Date is required')"
              ref="date"
              class="ml-1"
            >
              <flat-pickr
                :config="config"
                ref="date"
                v-model="attData.date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
            <b-button
              variant="success"
              class="ml-1"
              @click="Save()"
              :disabled="request"
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Save") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-table
          class="mt-1"
          ref="attTable"
          :items="filterAtt"
          :fields="newEntry ? attFields : attFields"
          show-empty
          :busy="attLoading"
          responsive
          hover
        >
          <template #head()="scope">
            <div>{{ $t(scope.label) }}</div>
          </template>
          <template #table-busy>
            <div
              class="d-flex justify-content-center mb-3"
              style="margin-top: 50px"
            >
              <b-spinner
                style="width: 3rem; height: 3rem"
                type="grow"
                variant="primary"
                :label="$t('Spinning')"
              ></b-spinner>
            </div>
          </template>
          <template #cell(index)="data">
            <b-badge variant="light-primary">
              {{ attData.records.indexOf(data.item) + 1 }}
            </b-badge>
          </template>
          <template #cell(grNo)="data">
            <b-badge style="margin-inline: 2px" variant="light-primary">
              {{ data.item.grNo }}
            </b-badge>
          </template>
          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="32"
                  :src="data.item.avatar"
                  variant="light-primary"
                />
              </template>

              <b-link class="font-weight-bold d-block text-nowrap">
                {{ data.item.name }}
              </b-link>
              <small class="text-muted">
                <b-badge variant="light-primary">
                  {{ $t("GR") }} - {{ data.item.grNo }}
                </b-badge>
              </small>
            </b-media>
          </template>
          <template #cell(present)="data">
            <b-form-group
              label=""
              :invalid-feedback="$t('Invalid entry')"
              :ref="'present' + data.index"
            >
              <b-form-input
                :id="'mid' + data.index"
                style="width: 80px"
                class="present-field"
                :placeholder="$t('Enter present days here')"
                v-model="data.item.present"
                @input="checkValues(data.index)"
                @keyup.enter="moveFocus(data.index)"
              />
            </b-form-group>
          </template>

          <template #head(actions)="data">
            <div class="mr-5 text-right">
              <span>{{ data.label }}</span>
            </div>
          </template>

          <template #cell(percentage)="data">
            <b-badge variant="light-primary">
              {{ data.item.obj.meta_subj_percenatge }} <span>%</span>
            </b-badge>
          </template>

          <template #cell(status)="data">
            <b-badge
              :variant="
                data.item.obj.status == 'PASSED'
                  ? 'light-success'
                  : 'light-danger'
              "
            >
              {{ data.item.obj.status }}
            </b-badge>
          </template>
        </b-table>
      </b-row>
    </b-card>

    <b-modal
      v-model="resultJobVisible"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
      body-class="result-job-modal"
      content-class="result-job-modal__content"
    >
      <div class="result-job-modal__wrap">
        <div class="result-job-modal__loader">
          <svg class="result-job-modal__ring" viewBox="0 0 120 120">
            <circle
              class="result-job-modal__ring-track"
              cx="60"
              cy="60"
              r="52"
            />
            <circle
              class="result-job-modal__ring-fill"
              cx="60"
              cy="60"
              r="52"
              :style="{ strokeDashoffset: resultJobRingOffset }"
            />
          </svg>
          <div class="result-job-modal__loader-center">
            <span class="result-job-modal__percent">{{
              resultJobProgress
            }}</span>
            <span class="result-job-modal__percent-sign">%</span>
          </div>
        </div>

        <h5 class="result-job-modal__title">Result Compilation</h5>
        <p class="result-job-modal__message">{{ resultJobMessage }}</p>

        <div v-if="resultJobShared" class="result-job-modal__info">
          <feather-icon icon="UsersIcon" size="15" />
          <span>
            Another user is already generating — showing shared progress
          </span>
        </div>

        <div class="result-job-modal__bar-wrap">
          <div
            class="result-job-modal__bar-fill"
            :style="{ width: resultJobProgress + '%' }"
          ></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BImg,
  VBTooltip,
  BFormCheckbox,
  BFormGroup,
  BForm,
  BMediaAside,
  BAside,
  BSpinner,
  BCardTitle,
  BCardText,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BInputGroupAppend,
  BInputGroup,
  BAvatar,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { getUploadPath, uploadToMySkool } from "@/utils/gdriveUpload";
import * as XLSX from "xlsx";

export default {
  components: {
    BCard,
    BCardTitle,
    BRow,
    BBadge,
    BTable,
    BImg,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    BLink,
    BAvatar,
    BMedia,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    if (!this.$store.state.rights[this.$route.name]) {
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];

      this.collection = this.$store.state.marksSelection;

      if (!Array.isArray(this.collection)) {
        this.$store.commit("setSelection", []);
      }
      let data = this.collection.find(
        (el) => el.campusID == this.$store.state.userData.cId
      );
      if (data) {
        this.myObj = {
          campusID: data.campusID,
          clsID: data.clsID,
          sec: data.secID,
          examTypeID: data.examTypes ? data.examTypes : [],
          sessionID: data.sessionID,
          dtFrom: "",
          dtTo: "",
        };
      }
      this.LoadData();
      this.loadSettings();
      this.LoadSettingsAll();
    }
  },
  computed: {
    stats() {
      const total = this.items.length;
      const passed = this.items.filter(
        (i) => i.result && i.result.toUpperCase() === "PASSED"
      ).length;
      const failed = this.items.filter(
        (i) => i.result && i.result.toUpperCase().includes("FAIL")
      ).length;

      const gradeCounts = {};
      this.items.forEach((i) => {
        if (i.grade) {
          const g = i.grade.trim();
          if (g !== "") {
            gradeCounts[g] = (gradeCounts[g] || 0) + 1;
          }
        }
      });

      const grades = Object.keys(gradeCounts)
        .map((g) => ({
          name: g,
          count: gradeCounts[g],
        }))
        .sort((a, b) => a.name.localeCompare(b.name));

      return { total, passed, failed, grades };
    },
    filters: function () {
      return this.items.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.father_name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.grNo.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    filterAtt: function () {
      return this.attData.records.filter((pro) => {
        return (
          pro.name.toLowerCase().match(this.searchQuery.toLowerCase()) ||
          pro.grNo.toLowerCase().match(this.searchQuery.toLowerCase())
        );
      });
    },
    isDatewise() {
      return ["myskooliota", "myskooliota2", "myskoolmakjauhar"].includes(
        this.reportDomain
      );
    },
    isSeparatePrintDate() {
      return ["myskooliota", "myskooliota2"].includes(this.reportDomain);
    },
    resultJobRingOffset() {
      const circumference = 2 * Math.PI * 52;
      const progress = Math.min(Math.max(this.resultJobProgress, 0), 100);
      return circumference - (progress / 100) * circumference;
    },
  },
  data() {
    return {
      rights: {},
      pictureMap: {},
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      resultUrl: this.$store.state.domain,
      collection: [],
      current: null,
      iPrint: false,
      iShow: false,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
      },
      config2: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      request: false,
      saving: false,
      settLoading: false,
      visibility2: false,
      visibility3: false,
      visibility4: false,
      visibility5: false,
      visibility6: false,
      pubObj: {
        campusID: this.$store.state.userData.cId,
        dtFrom: "",
        dtTo: "",
      },
      publishRange: null,
      publishing: false,
      isLock: false,
      isPublish: false,
      loadingStatus: false,
      locking: false,
      sidebarTitle: "Add Balance",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      sheetLoading: false,
      gridLoading: false,
      resultJobVisible: false,
      resultJobProgress: 0,
      resultJobMessage: "",
      resultJobShared: false,
      index: null,
      passCount: 0,
      failCount: 0,
      fields: [
        {
          label: "S.No",
          key: "index",
          thClass: "sticky-sno",
          tdClass: "sticky-sno",
        },
        {
          label: "GR #",
          key: "grNo",
          thClass: "sticky-gr",
          tdClass: "sticky-gr",
        },
        {
          label: "name",
          key: "name",
          thClass: "sticky-name",
          tdClass: "sticky-name",
        },
        { label: "Marks", key: "obtainedMarks" },
        { label: "Percentage", key: "percentage" },
        { label: "Rank", key: "rank" },
        { label: "Grade", key: "grade" },
        { label: "Result", key: "result" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      sections: [],
      secText: "Section",
      classes: [],
      classesOptions: [],
      currentSections: [],
      subjectList: [],
      classText: "Class",
      sessions: [],
      sessionText: "Session",
      examType: [],
      examText: "Exam Type",
      selected: null,
      rangeDate: "",
      myObj: {
        campusID: this.$store.state.userData.cId,
        clsID: 0,
        sec: 0,
        examTypeID: [],
        sessionID: 0,
        dtFrom: "",
        dtTo: "",
        maxRank: 10,
        absentDeduction: 0,
      },
      absentMarks: 0,
      marksObj: {},
      settObj: this.$store.state.resultSetting,
      showGrid: false,
      showDetils: false,
      subLoading: false,
      rewardObj: {
        fee: null,
        clsID: null,
        secIDs: null,
      },
      rewardSections: [],
      selectedIDs: [],
      attLoading: false,
      showAtt: false,
      attData: {
        totalDays: null,
        date: null,
        records: [
          {
            id: 1,
            name: "test",
            present: 72,
          },
          {
            id: 12,
            name: "testwq",
            present: 86,
          },
        ],
      },
      currentExam: "",
      currentSession: "",
      attFields: [
        { label: "name", key: "name" },
        { label: "days present", key: "present" },
      ],
      exporting: false,
      exportingRes: false,
      currentExp: 0,
      graceObj: {
        classID: 0,
        sectionID: 0,
        sessionID: 0,
        examIDs: [],
        basedOn: 0,
        type: "",
      },
      graceSections: [],
      gracing: false,
      typeOptions: [
        { text: "Average", value: "average" },
        { text: "Grand", value: "grand" },
      ],
      examNames: [],
      lockObj: null,
      sending: false,
      approveObj: null,
      isApproved: false,
      approving: false,
      termDate: null,
      resultPrintDateObj: null,
      logoObj: null,
      headerObj: null,
      footerObj: null,
      stampObj: null,
      headerImageObj: null,
      imgLoading: false,
      footerImageObj: null,
      footerImgLoading: false,
      promotedObj: null,
      courseObj: null,
      titleObj: null,
      sheetObj: null,
      formatObj: null,
      publishLoadObj: null,
      publishData: [],
      otherReportsObj: null,
      stLoading: false,
      formatOptions: [
        { text: "Assessment", value: "assessment" },
        { text: "Mid Term", value: "mid_term" },
        { text: "Final Term", value: "final_term" },
      ],
      reportOptions: [
        { text: "Ranking Sheet", value: "ranking" },
        { text: "Cumulative Sheet", value: "cumulative" },
      ],
      reportFilter: {
        type: "ranking",
        subjectID: 0,
        withU: true,
      },
      summaryObj: {
        clsID: [0],
        examTypeID: [],
        singleExamID: 0,
        sessionID: 0,
      },
      singleSummary: ["myskoolhhpublic"],
    };
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      postObj: "postObj",
      put: "put",
      delete: "delete",
    }),

    async LoadSubjectByClass() {
      if (
        this.otherReportsObj?.valueBool &&
        this.myObj.clsID > 0 &&
        this.myObj.sec > 0
      ) {
        this.subLoading = true;
        this.subjectList = [];
        this.reportFilter.subjectID = 0;

        let myitem = await this.get({
          url:
            this.$store.state.domain +
            "TeacherClasses/LoadSubjectByClass?db=" +
            this.$store.state.userData.db +
            "&campusID=" +
            this.$store.state.userData.cId +
            "&classID=" +
            this.myObj.clsID +
            "&secID=" +
            this.myObj.sec,
          token: this.$store.state.userData.token,
        });
        this.subLoading = false;
        this.subjectList = myitem;
      }
    },
    async dataSheet(type) {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        // Profectus: Vue datasheet only for Pre-Junior / Junior 1–2 (same as Early Year Show)
        if (
          this.isProfectusReportDomain() &&
          !type &&
          this.isEarlyYearReportClass()
        ) {
          this.openDatasheetPrint();
          return;
        }

        this.sheetLoading = true;
        let obj = {
          campusID: this.myObj.campusID,
          clsID: this.myObj.clsID,
          sec: this.myObj.sec,
          examTypeID: this.myObj.examTypeID,
          sessionID: this.myObj.sessionID,
          dtFrom: null,
          dtTo: null,
        };

        const dtText = this.getDateText(this.settObj.rangeDate);

        let res = await this.runCreateResultInPhases(
          2,
          this.buildCreateResultPayload(obj),
          { fetchResult: false }
        );
        this.sheetLoading = false;
        if (!res) return;

        let url = `https://${this.reportDomain}.myskool.app/Exams/ShowDatasheetMultiple?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.myObj.clsID}&sec=${this.myObj.sec}&examID=${this.myObj.examTypeID}&sessionID=${this.myObj.sessionID}&sIDs=${this.selectedIDs}&date=${dtText}`;
        if (type) {
          url = `https://${this.reportDomain}.myskool.app/Exams/ShowReport?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.myObj.clsID}&sec=${this.myObj.sec}&examID=${this.myObj.examTypeID}&sessionID=${this.myObj.sessionID}&sIDs=&date=${dtText}&type=${type}&subIDs=${this.reportFilter.subjectID}`;
        }

        window.open(url, "_blank");
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    openDatasheetPrint() {
      if (!this.isProfectusReportDomain() || !this.isEarlyYearReportClass()) {
        return;
      }

      if (
        !(
          this.myObj.clsID > 0 &&
          this.myObj.sec > 0 &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        )
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const dtText = this.getDateText(this.settObj.rangeDate || "");
      const route = this.$router.resolve({
        name: "datesheet-print",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          classID: this.myObj.clsID,
          sectionID: this.myObj.sec,
          examTypeID: this.myObj.examTypeID[0],
          sessionID: this.myObj.sessionID,
          clsName: this.getSelectedClassName(),
          secName: this.getSelectedSectionName(),
          examTypeName: this.getSelectedExamTypeName(),
          sessionName: this.getSelectedSessionName(),
          date: dtText || "",
          ...(this.selectedIDs && this.selectedIDs.length
            ? { sIDs: this.selectedIDs.join(",") }
            : {}),
        },
      });
      window.open(route.href, "_blank");
    },
    getDateText(dtValue) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let myDate = "";
      if (dtValue.indexOf(" to ") > -1) {
        let dt = dtValue.split(" to ");
        let dtFrom = dt[0].split("-");
        let dtTo = dt[1].split("-");
        let mFrom = months[parseInt(dtFrom[1]) - 1];
        let mTo = months[parseInt(dtTo[1]) - 1];

        myDate = dtFrom[2] + "-" + mFrom + "-" + dtFrom[0];
        if (dtFrom != dtTo) {
          myDate += " to " + dtTo[2] + "-" + mTo + "-" + dtTo[0];
        }
      } else {
        if (dtValue && dtValue.length > 0) {
          let dt = dtValue;
          let dtFrom = dt.split("-");
          let mFrom = months[parseInt(dtFrom[1]) - 1];
          myDate = dtFrom[2] + "-" + mFrom + "-" + dtFrom[0];
        } else {
          myDate = "";
        }
      }
      return myDate;
    },

    async sendMessage() {
      this.myObj.dtFrom = null;
      this.myObj.dtTo = null;
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        if (this.isDatewise || this.reportDomain == "myskoolmerittoexcel") {
          if (this.settObj.rangeDate.indexOf(" to ") > -1) {
            var dt = this.settObj.rangeDate.split(" to ");
            this.myObj.dtFrom = dt[0];
            this.myObj.dtTo = dt[1];
          } else {
            if (this.settObj.rangeDate && this.settObj.rangeDate.length > 0) {
              var dt = this.settObj.rangeDate;
              this.myObj.dtFrom = dt;
              this.myObj.dtTo = dt;
            } else {
              this.myObj.dtFrom = null;
              this.myObj.dtTo = null;
            }
          }
        }

        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: this.$t("You want to send result on WhatsApp?"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("Yes!"),
        });
        if (result.isConfirmed) {
          this.sending = true;
          let res = await this.post({
            url:
              this.$store.state.domain +
              "Marks/CreateResult?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            context: this,
            subjects: true,
            token: this.$store.state.userData.token,
          });
          if (res) {
            try {
              if (this.selectedIDs.length > 0) {
                await this.postObj({
                  url:
                    this.$store.state.domain +
                    "Marks/SendWhatsapp?db=" +
                    this.$store.state.userData.db +
                    "&cID=" +
                    this.$store.state.userData.cId +
                    "&userID=" +
                    this.$store.state.userData.userID,
                  message: this.$t("Result sent on WhatsApp!"),
                  context: this,
                  body: {
                    ...this.myObj,
                    sIDs: this.selectedIDs,
                  },
                  token: this.$store.state.userData.token,
                });
              } else {
                await this.postObj({
                  url:
                    this.$store.state.domain +
                    "Marks/SendWhatsapp?db=" +
                    this.$store.state.userData.db +
                    "&cID=" +
                    this.$store.state.userData.cId +
                    "&userID=" +
                    this.$store.state.userData.userID,
                  message: this.$t("Result sent on WhatsApp!"),
                  context: this,
                  body: this.myObj,
                  token: this.$store.state.userData.token,
                });
              }
            } catch (error) {
            } finally {
              this.sending = false;
            }
          } else {
            this.$bvToast.toast(this.$t("Something went wrong!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          }
          this.sending = false;
        }
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    openGrace() {
      this.visibility5 = true;
    },
    FillGraceSec() {
      this.graceSections = [];
      this.graceSections = this.classes.find(
        (el) => el.cls.id == this.graceObj.classID
      ).sections;

      this.graceObj.sectionID = 0;
    },
    async ApplyGrace() {
      if (
        this.graceObj.classID > 0 &&
        this.graceObj.sectionID > 0 &&
        this.graceObj.sessionID > 0 &&
        this.graceObj.examIDs.length > 0 &&
        this.graceObj.basedOn > 0 &&
        this.graceObj.type !== ""
      ) {
        this.gracing = true;
        let res = await this.post({
          url:
            this.$store.state.domain +
            "Marks/ApplyBonus?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId,
          body: this.graceObj,
          message: this.$t("Marks Updated"),
          context: this,
          token: this.$store.state.userData.token,
        });
        this.gracing = false;
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    openSummary() {
      this.visibility6 = true;
    },
    setSummaryClasses() {
      if (this.summaryObj.clsID.at(-1) == 0) {
        this.summaryObj.clsID = [0];
      } else {
        this.summaryObj.clsID = this.summaryObj.clsID.filter((el) => el != 0);
      }
    },
    showSummary() {
      if (
        this.summaryObj.clsID.length > 0 &&
        (this.singleSummary.includes(this.reportDomain)
          ? this.summaryObj.singleExamID > 0
          : this.summaryObj.examTypeID.length > 0) &&
        this.summaryObj.sessionID > 0
      ) {
        const examID = this.singleSummary.includes(this.reportDomain)
          ? this.summaryObj.singleExamID
          : this.summaryObj.examTypeID[0].id;

        if (this.summaryObj.examTypeID.length > 1) {
          const sorted = [...this.summaryObj.examTypeID].sort(
            (a, b) => (Number(a.id) || 0) - (Number(b.id) || 0)
          );
          const examNames = sorted
            .map((el) => el.examType)
            .filter((t) => t != null && String(t).trim() !== "")
            .join(" + ");

          const url = `https://${
            this.reportDomain
          }.myskool.app/Exams/Summary?dbb=${
            this.$store.state.userData.db
          }&cID=${this.$store.state.userData.cId}&cls=${
            this.summaryObj.clsID
          }&examID=${examID}&sessionID=${
            this.summaryObj.sessionID
          }&type=summary-aggregate&examNames=${encodeURIComponent(examNames)}`;
          window.open(url, "_blank");
        } else {
          const url = `https://${this.reportDomain}.myskool.app/Exams/Summary?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.summaryObj.clsID}&examID=${examID}&sessionID=${this.summaryObj.sessionID}&type=summary-all`;
          window.open(url, "_blank");
        }
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    setDate() {
      let d = this.publishRange.split(" to ");
      this.pubObj.dtFrom = d[0];
      this.pubObj.dtTo = d[1];
    },
    checkPubFrom() {
      var elem = this.$refs["pub_from"];
      if (!this.pubObj.dtFrom) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPubTill() {
      var elem = this.$refs["pub_till"];
      if (!this.pubObj.dtTo) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async CheckStatus() {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        this.loadingStatus = true;
        let res = await this.get({
          url:
            this.$store.state.domain +
            "Marks/LoadPublish?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&clsID=" +
            this.myObj.clsID +
            "&secID=" +
            this.myObj.sec +
            "&examID=" +
            this.myObj.examTypeID[0] +
            "&sessionID=" +
            this.myObj.sessionID,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (res == "") {
          this.isLock = false;
          this.isPublish = false;
          this.pubObj.dtFrom = "";
          this.pubObj.dtTo = "";
        } else {
          this.isLock = res.isLocked;
          this.isPublish = res.isPublished;
          this.pubObj.dtFrom = res.publishedFrom;
          this.pubObj.dtTo = res.publishedTo;
        }

        this.loadingStatus = false;
        this.visibility4 = true;
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    async publish() {
      this.checkPubFrom();
      this.checkPubTill();
      if (this.checkPubFrom() == true && this.checkPubTill() == true) {
        this.publishing = true;

        if (this.isPublish) {
          let saveObj = {
            cID: this.myObj.clsID,
            secID: this.myObj.sec,
            examID: this.myObj.examTypeID[0],
            sessionID: this.myObj.sessionID,
            dtFrom: this.pubObj.dtFrom,
            dtTo: this.pubObj.dtTo,
            userID: this.$store.state.userData.userID,
          };
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Marks/UnpublishResult?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: saveObj,
            message: this.$t("Result Unpublished successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.publishing = false;

          if (status) this.visibility4 = false;
        } else {
          let saveObj = {
            cID: this.myObj.clsID,
            secID: this.myObj.sec,
            examID: this.myObj.examTypeID[0],
            sessionID: this.myObj.sessionID,
            dtFrom: this.pubObj.dtFrom,
            dtTo: this.pubObj.dtTo,
            userID: this.$store.state.userData.userID,
            sIDs: this.selectedIDs.join(","),
          };
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Marks/PublishResult?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: saveObj,
            message: this.$t("Result Published successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.publishing = false;

          if (status) this.visibility4 = false;
        }
      } else {
        this.$bvToast.toast(this.$t("Please select publish duration date"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    async checkLock() {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        let res = await this.get({
          url:
            this.$store.state.domain +
            "Marks/LoadPublish?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&clsID=" +
            this.myObj.clsID +
            "&secID=" +
            this.myObj.sec +
            "&examID=" +
            this.myObj.examTypeID[0] +
            "&sessionID=" +
            this.myObj.sessionID,
          context: this,
          token: this.$store.state.userData.token,
        });
        if (res == "") {
          this.isLock = false;
          this.isPublish = false;
          this.pubObj.dtFrom = "";
          this.pubObj.dtTo = "";
        } else {
          this.isLock = res.isLocked;
          this.isPublish = res.isPublished;
          this.pubObj.dtFrom = res.publishedFrom;
          this.pubObj.dtTo = res.publishedTo;
        }
      }
    },
    async lock() {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        let saveObj = {
          cID: this.myObj.clsID,
          secID: this.myObj.sec,
          examID: this.myObj.examTypeID[0],
          sessionID: this.myObj.sessionID,
          dtFrom: null,
          dtTo: null,
          userID: this.$store.state.userData.userID,
        };
        if (this.isLock) {
          this.locking = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Marks/Unlock" +
              "?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: saveObj,
            message: this.$t("Result unlocked successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.locking = false;
          if (status) this.checkLock();
        } else {
          this.locking = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Marks/Lock" +
              "?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: saveObj,
            message: this.$t("Result locked successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.locking = false;
          if (status) this.checkLock();
        }
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    exportData() {
      if (this.items.length > 0) {
        this.exporting = true;

        const newData = this.items.map((item) => ({
          grNo: item.grNo,
          name: item.name,
          father: item.father_name,
          total: item.totalMarks,
          obtained: item.obtainedMarks,
          percenatge: item.percentage,
          grade: item.grade,
          rank: item.rank,
          result: item.result,
        }));

        const worksheet = XLSX.utils.json_to_sheet(newData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
        XLSX.writeFile(workbook, "result.xlsx");

        this.exporting = false;
      } else {
        this.$bvToast.toast(
          this.$t("Please first create a result to export."),
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
      }
    },
    async expResult(sID) {
      this.currentExp = sID;
      this.exportingRes = true;

      let obj = {
        campusID: this.myObj.campusID,
        clsID: this.myObj.clsID,
        sec: this.myObj.sec,
        examTypeID: this.myObj.examTypeID,
        sessionID: this.myObj.sessionID,
        dtFrom: null,
        dtTo: null,
      };
      let res = await this.runCreateResultInPhases(
        2,
        this.buildCreateResultPayload(obj),
        { fetchResult: false }
      );
      if (!res) {
        this.exportingRes = false;
        return;
      }

      let examNames = [];
      this.myObj.examTypeID.forEach((el) => {
        let obj = this.examType.find((elem) => elem.id == el);
        if (obj) examNames.push(obj.examType);
      });

      var url = `https://${this.reportDomain}.myskool.app/Exams/ShowExport?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.myObj.clsID}&sec=${this.myObj.sec}&examID=${this.myObj.examTypeID}&sessionID=${this.myObj.sessionID}&sIDs=${sID}&date=&examType=${examNames}`;

      axios
        .get(url)
        .then((res) => {
          if (res.data.status == "success") {
            window.open(res.data.data[0], "_blank");
          } else {
            this.$bvToast.toast(this.$t("Something went wrong!"), {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            });
          }
        })
        .catch((error) => {
          console.error("err", error);
          this.$bvToast.toast(this.$t("Something went wrong!"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        })
        .finally(() => (this.exportingRes = false));
    },
    downloadPDF(pdfUrl) {
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = pdfUrl.split("/").at(-1);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    firstFocus() {
      let first = document.querySelector(".present-field");
      first.focus();
      first.select();
    },
    checkValues(ind) {
      var elem = this.$refs["present" + ind];
      if (
        this.filterAtt[ind].present < 0 ||
        parseInt(this.filterAtt[ind].present) > parseInt(this.attData.totalDays)
      ) {
        return (elem.state = false);
      } else {
        return (elem.state = undefined);
      }
    },
    async moveFocus(ind, item) {
      let all = document.querySelectorAll(".present-field");

      if (ind + 1 != all.length) {
        all[ind + 1].focus();
        all[ind + 1].select();
      }
    },

    async openAttendance() {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        this.showGrid = false;
        this.showAtt = true;
        this.currentExam = this.examType.find(
          (el) => el.id == this.myObj.examTypeID[0]
        ).examType;
        this.currentSession = this.sessions.find(
          (el) => el.id == this.myObj.sessionID
        ).session;
        setTimeout(() => {
          this.firstFocus();
        }, 500);
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },

    async Edit(item) {
      this.marksObj = item;
      this.visibility = true;
      this.sidebarTitle = "Edit Marks";
      this.sidebarButton = "Update";
      var elem = this.$refs["marks"];
      elem.state = undefined;
    },

    AddOpen() {
      this.myObj = {
        id: 0,
        account: 0,
        balance: 0,
        campusID: this.$store.state.userData.cId,
      };
      this.visibility = true;
      this.sidebarTitle = "Add balance";
      this.sidebarButton = "Save";
      var elem = this.$refs["account"];
      elem.state = undefined;
      var elem = this.$refs["balance"];
      elem.state = undefined;
    },

    CheckMarks() {
      var elem = this.$refs["marks"];
      var re = /^[0-9]+$/;
      if (re.test(this.marksObj.obtained_marks)) {
        this.marksObj.obtained_marks = parseInt(this.marksObj.obtained_marks);
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },
    getDues(sID) {
      if (this.publishLoadObj && this.publishLoadObj.valueBool) {
        let student = this.publishData.find((el) => el.sID == sID);
        return student ? student.dues : 0;
      }
      return 0;
    },
    getInitials(name) {
      if (!name) return "?";
      const parts = name.trim().split(" ");
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    },
    FillRewardSec(text) {
      this.rewardSections = [];
      this.classes.forEach((elem) => {
        if (elem.cls.id === this.rewardObj.clsID) {
          if (elem.sections.length != 0) {
            this.rewardSections = elem.sections;
          } else {
            this.rewardSections = [];
          }
        }
      });
      if (text != "filled") this.rewardObj.secIDs = null;
    },
    setSections() {
      if (this.rewardObj.secIDs.at(-1) == 0) {
        this.rewardObj.secIDs = [0];
      } else {
        this.rewardObj.secIDs = this.rewardObj.secIDs.filter((el) => el != 0);
      }
    },
    FillSections(text) {
      if (this.reportDomain == "myskoolmakjauhar") {
        if (this.myObj.clsID == 0) {
          this.currentSections = [{ id: 0, section: "All Sections" }];
          this.myObj.sec = 0;
        } else {
          this.classes.forEach((elem) => {
            if (elem.cls.id === this.myObj.clsID) {
              if (elem.sections.length != 0) {
                this.currentSections = [
                  { id: 0, section: "All Sections" },
                  ...elem.sections,
                ];
              } else {
                this.currentSections = [{ id: 0, section: "All Sections" }];
              }
            }
          });
          if (text != "filled") {
            this.myObj.sec = 0;
          }
        }
      } else {
        this.classes.forEach((elem) => {
          if (elem.cls.id === this.myObj.clsID) {
            if (elem.sections.length != 0) {
              this.currentSections = elem.sections;
            } else {
              this.currentSections = [];
            }
          }
        });
        if (text != "filled") this.myObj.sec = 0;
      }
    },
    ViewDetails(item) {
      this.showGrid = false;
      this.showDetils = true;
    },

    Back() {
      this.showAtt = false;
      this.showGrid = true;
    },
    async loadSettings() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettings?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        body: [
          "auto_lock",
          "result_approval",
          "term_dates",
          "result_print_date",
          "show_header",
          "show_footer",
          "show_logo",
          "show_stamp",
          "show_promoted",
          "course_marks",
          "examTitle",
          "result_format",
          "other_result_reports",
          "header_image",
          "footer_image",
        ],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.lockObj = res.find((el) => el.key == "auto_lock");

      if (this.lockObj && this.lockObj.valueNumber == null) {
        this.lockObj.valueNumber = 1;
      }

      this.termDate = res.find((el) => el.key == "term_dates");
      const currentCampusId = String(this.$store.state.userData.cId);
      this.resultPrintDateObj =
        res.find(
          (el) =>
            el.key == "result_print_date" &&
            String(el.campusID) === currentCampusId
        ) || res.find((el) => el.key == "result_print_date");
      if (this.resultPrintDateObj && this.resultPrintDateObj.value) {
        if (this.isSeparatePrintDate) {
          this.settObj.printDate = this.resultPrintDateObj.value;
        } else {
          this.settObj.rangeDate = this.resultPrintDateObj.value;
        }
        this.$store.commit("setResult", this.settObj);
      }
      this.approveObj = res.find((el) => el.key == "result_approval");
      this.headerObj = res.find((el) => el.key == "show_header");
      this.footerObj = res.find((el) => el.key == "show_footer");
      this.logoObj = res.find((el) => el.key == "show_logo");
      this.stampObj = res.find((el) => el.key == "show_stamp");
      this.promotedObj = res.find((el) => el.key == "show_promoted");
      this.courseObj = res.find((el) => el.key == "course_marks");
      this.titleObj = res.find((el) => el.key == "examTitle");
      this.formatObj = res.find((el) => el.key == "result_format");
      this.otherReportsObj = res.find((el) => el.key == "other_result_reports");

      this.headerImageObj = res.find((el) => el.key == "header_image");
      this.footerImageObj = res.find((el) => el.key == "footer_image");
    },
    async LoadSettingsAll() {
      let res = await this.post({
        url:
          this.$store.state.domain +
          "Settings/getSettingsAll?db=" +
          this.$store.state.userData.db,
        body: ["datasheetOnResult", "result_url", "publish_load"],
        context: this,
        token: this.$store.state.userData.token,
        subjects: true,
      });
      this.sheetObj = res.find((el) => el.key == "datasheetOnResult");
      this.publishLoadObj = res.find((el) => el.key == "publish_load");

      const urlObj = res.find((el) => el.key == "result_url");
      if (urlObj && urlObj.value) {
        this.resultUrl = urlObj.value;
      } else {
        this.resultUrl = this.$store.state.domain;
      }
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.classes = await this.get(obj);
      this.classesOptions = [];
      this.classes.forEach((el) => this.classesOptions.push(el.cls));
      this.FillSections("filled");

      var obj2 = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.sessions = await this.get(obj2);

      var obj3 = {
        url:
          this.$store.state.domain +
          "ExamTypes/LoadData?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId +
          "&status=active&page=1&pageSize=1000",
        token: this.$store.state.userData.token,
      };
      const response = await this.get(obj3);
      this.examType = (response.data || response || []).map((item) => ({
        id: item.id,
        examType: item.examType,
      }));

      this.dataLoading = false;
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        this.checkLock();
      }
    },
    getSelectedClassName() {
      const match = this.classesOptions.find(
        (elem) => elem.id == this.myObj.clsID
      );
      return match ? String(match.name || "").trim() : "";
    },
    getSelectedSectionName() {
      const match = this.currentSections.find(
        (elem) => elem.id == this.myObj.sec
      );
      return match ? String(match.section || match.name || "").trim() : "";
    },
    getSelectedExamTypeName() {
      const examId = this.myObj.examTypeID[0];
      const match = this.examType.find((elem) => elem.id == examId);
      return match ? String(match.examType || "").trim() : "";
    },
    getSelectedSessionName() {
      const match = this.sessions.find(
        (elem) => elem.id == this.myObj.sessionID
      );
      return match ? String(match.session || "").trim() : "";
    },
    isProfectusReportDomain() {
      return this.reportDomain === "myskoolprofectus";
    },
    isWhssReportDomain() {
      const d = String(this.reportDomain || "")
        .replace(/_/g, "")
        .toLowerCase();
      return d === "myskoolwhss" || d.includes("whss");
    },
    isWhssEarlyYearClass() {
      if (!this.isWhssReportDomain()) return false;
      const name = String(this.getSelectedClassName() || "")
        .toUpperCase()
        .replace(/[^A-Z0-9 ]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      if (!name) return false;
      return (
        /\bPRE\s*NURSERY\b/.test(name) ||
        /\bNURSERY\b/.test(name) ||
        /\bKG\b/.test(name) ||
        /\bKINDERGARTEN\b/.test(name)
      );
    },
    isFarabiReportDomain() {
      return this.reportDomain === "myskoolfarabicoa";
    },
    openFarabiResult(sIDs = "") {
      const ids =
        sIDs !== "" && sIDs !== undefined && sIDs !== null
          ? String(sIDs)
          : (this.selectedIDs || []).join(",");

      const route = this.$router.resolve({
        name: "farabi-result",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          classID: this.myObj.clsID,
          sectionID: this.myObj.sec,
          examTypeID: this.myObj.examTypeID.join(","),
          sessionID: this.myObj.sessionID,
          clsName: this.getSelectedClassName(),
          secName: this.getSelectedSectionName(),
          examTypeName: this.getSelectedExamTypeName(),
          sessionName: this.getSelectedSessionName(),
          ...(ids ? { sIDs: ids } : {}),
        },
      });
      window.open(route.href, "_blank");
    },
    /** myskoolhpgs: current academic session (e.g. 2026-2027) */
    getCurrentSession() {
      const list = this.sessions || [];
      const flagged = list.find(
        (s) => s.isCurrentSession === true || s.isCurrentSession === 1
      );
      if (flagged) return flagged;

      // Fallback: session with highest ending year from "YYYY-YYYY"
      let best = null;
      let bestYear = -1;
      list.forEach((s) => {
        const text = String(s.session || "");
        const match = text.match(/(\d{4})\s*[-–]\s*(\d{4})/);
        const endYear = match ? Number(match[2]) : Number(s.id) || 0;
        if (endYear >= bestYear) {
          bestYear = endYear;
          best = s;
        }
      });
      return best;
    },
    /** myskoolhpgs only: selected session is older than current → prevResult=true */
    shouldPassPrevResult() {
      if (this.reportDomain !== "myskoolhpgs") return false;
      if (!this.myObj.sessionID) return false;
      const current = this.getCurrentSession();
      if (!current) return false;
      return Number(this.myObj.sessionID) !== Number(current.id);
    },
    buildCreateResultPhasesAsyncUrl(phase) {
      let url =
        this.resultUrl +
        "Marks/CreateResultInPhasesAsync?db=" +
        encodeURIComponent(this.$store.state.userData.db) +
        "&phase=" +
        phase;
      if (this.shouldPassPrevResult()) {
        url += "&prevResult=true";
      }
      return url;
    },
    buildCreateResultPayload(sourceObj) {
      return {
        campusID: sourceObj.campusID,
        clsID: sourceObj.clsID,
        sec: sourceObj.sec,
        examTypeID: sourceObj.examTypeID,
        sessionID: sourceObj.sessionID,
        dtFrom: sourceObj.dtFrom ?? null,
        dtTo: sourceObj.dtTo ?? null,
        absentDeduction: sourceObj.absentDeduction ?? 0,
      };
    },
    async startResultCompilation(payload, phase) {
      const res = await axios.post(
        this.buildCreateResultPhasesAsyncUrl(phase),
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.state.userData.token}`,
          },
        }
      );
      return res.data;
    },
    async pollJobStatus(jobID, onProgress) {
      const token = this.$store.state.userData.token;
      while (true) {
        const res = await axios.get(
          this.$store.state.domain + "BackgroundJobs/GetJobStatus/" + jobID,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = res.data;
        if (onProgress) onProgress(data);
        if (data.status === "succeeded") return { ok: true, jobID };
        if (data.status === "failed")
          return { ok: false, error: data.error || "Compilation failed" };
        if (data.status === "notFound")
          return { ok: false, error: "Job not found" };
        await new Promise((r) => setTimeout(r, 2000));
      }
    },
    async fetchJobResult(jobID) {
      const res = await axios.get(
        this.$store.state.domain +
          "Marks/GetCreateResultInPhasesJobResult/" +
          jobID,
        {
          headers: {
            Authorization: `Bearer ${this.$store.state.userData.token}`,
          },
        }
      );
      return res.data;
    },
    async runCreateResultInPhases(phase, payload, options = {}) {
      const { fetchResult = true, successMessage = null } = options;

      this.resultJobProgress = 0;
      this.resultJobMessage = "Starting result compilation...";
      this.resultJobShared = false;
      this.resultJobVisible = true;

      try {
        const start = await this.startResultCompilation(payload, phase);

        if (start.status === "error") {
          this.$bvToast.toast(start.message || "Failed to start compilation", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          return false;
        }

        const jobID = start.jobID;
        if (!jobID) {
          this.$bvToast.toast("No job ID returned", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          return false;
        }

        if (start.status === "already_running") {
          this.resultJobShared = true;
          this.resultJobMessage = "Joining shared compilation...";
        }

        const poll = await this.pollJobStatus(jobID, (p) => {
          this.resultJobProgress = p.percent ?? 0;
          this.resultJobMessage = "Compiling result...";
        });

        if (!poll.ok) {
          this.$bvToast.toast(poll.error || "Compilation failed", {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
          return false;
        }

        if (!fetchResult) return true;

        const result = await this.fetchJobResult(jobID);
        if (result.status === "success") {
          if (successMessage) {
            this.$bvToast.toast(successMessage, {
              title: this.$t("Notification"),
              variant: "success",
              toaster: "b-toaster-top-center",
            });
          }
          return result.data;
        }

        this.$bvToast.toast(result.message || "Could not load result", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return false;
      } catch (error) {
        this.$bvToast.toast(
          error.message || "Result compilation request failed",
          {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          }
        );
        return false;
      } finally {
        this.resultJobVisible = false;
        this.resultJobProgress = 0;
        this.resultJobMessage = "";
        this.resultJobShared = false;
      }
    },
    isPreJuniorClassName(className) {
      const normalized = String(className || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
      if (!normalized) return false;
      if (normalized.includes("PJR")) return true;
      if (normalized.includes("PREJNR")) return true;
      if (normalized.includes("PREJUNIOR")) return true;
      if (normalized.includes("PREJR")) return true;
      return false;
    },
    getJuniorGradeSuffix(className) {
      const normalized = String(className || "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
      if (!normalized) return null;

      let suffix = "";
      if (normalized.startsWith("JUNIOR")) {
        suffix = normalized.slice(6);
      } else if (normalized.startsWith("JR")) {
        suffix = normalized.slice(2);
      } else if (normalized.includes("JUNIOR")) {
        suffix = normalized.slice(normalized.indexOf("JUNIOR") + 6);
      } else {
        return null;
      }

      return suffix;
    },
    isJuniorClassName(className) {
      if (!className) return false;
      // Pre-junior / PJR already covered separately — do not treat as JR
      if (this.isPreJuniorClassName(className)) return false;

      const suffix = this.getJuniorGradeSuffix(className);
      if (suffix === null) return false;

      // Junior III / IV / V+ (and 3+) should use the normal result flow
      if (/^(III|IV|VI{0,3}|IX|X|[3-9]|1[0-2])[A-Z]*$/.test(suffix)) {
        return false;
      }

      // Early-year Junior only: Junior / JR / Junior I / Junior II (optional section letter)
      return /^(?:I{1,2}|1|2)?[A-Z]?$/.test(suffix);
    },
    isEarlyYearReportClass() {
      if (this.isWhssEarlyYearClass()) return true;
      if (!this.isProfectusReportDomain()) return false;
      const className = this.getSelectedClassName();
      return (
        this.isPreJuniorClassName(className) ||
        this.isJuniorClassName(className)
      );
    },
    openEarlyYearReportWhss(sIDs = "") {
      if (
        !(
          this.myObj.clsID > 0 &&
          this.myObj.sec > 0 &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        )
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const route = this.$router.resolve({
        name: "early-year-report-whss",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          classID: this.myObj.clsID,
          sectionID: this.myObj.sec,
          examTypeID: this.myObj.examTypeID[0],
          sessionID: this.myObj.sessionID,
          clsName: this.getSelectedClassName(),
          secName: this.getSelectedSectionName(),
          examTypeName: this.getSelectedExamTypeName(),
          sessionName: this.getSelectedSessionName(),
          ...(sIDs ? { sIDs: String(sIDs) } : {}),
          resultDate: this.getResultPrintDateValue(),
        },
      });
      window.open(route.href, "_blank");
    },
    openEarlyYearReport(sIDs = "") {
      if (this.isWhssEarlyYearClass()) {
        this.openEarlyYearReportWhss(sIDs);
        return;
      }
      if (!this.isProfectusReportDomain()) return;

      if (
        !(
          this.myObj.clsID > 0 &&
          this.myObj.sec > 0 &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        )
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
        return;
      }

      const route = this.$router.resolve({
        name: "early-year-report",
        query: {
          db: this.$store.state.userData.db,
          cID: this.$store.state.userData.cId,
          classID: this.myObj.clsID,
          sectionID: this.myObj.sec,
          examTypeID: this.myObj.examTypeID[0],
          sessionID: this.myObj.sessionID,
          clsName: this.getSelectedClassName(),
          secName: this.getSelectedSectionName(),
          examTypeName: this.getSelectedExamTypeName(),
          sessionName: this.getSelectedSessionName(),
          ...(sIDs ? { sIDs: String(sIDs) } : {}),
          resultDate: this.getResultPrintDateValue(),
        },
      });
      window.open(route.href, "_blank");
    },
    getResultPrintDateValue() {
      if (this.isSeparatePrintDate) {
        return this.settObj.printDate || "";
      }
      return this.settObj.rangeDate || "";
    },
    buildResultPrintDateSetting() {
      const value = this.getResultPrintDateValue();
      const campusID = this.$store.state.userData.cId;
      if (this.resultPrintDateObj) {
        return {
          ...this.resultPrintDateObj,
          value,
          campusID,
        };
      }
      return {
        id: 0,
        key: "result_print_date",
        value,
        campusID,
        valueBool: false,
        valueNumber: 0,
      };
    },
    async show() {
      this.myObj.campusID = this.$store.state.userData.cId;
      let data = {
        campusID: this.myObj.campusID,
        clsID: this.myObj.clsID,
        secID: this.myObj.sec,
        examID:
          this.myObj.examTypeID.length == 0 ? 0 : this.myObj.examTypeID[0],
        examTypes: this.myObj.examTypeID,
        sessionID: this.myObj.sessionID,
      };
      if (this.collection.length == 0) {
        this.collection.push(data);
      } else {
        const item = this.collection.find(
          (el) => el.campusID == this.$store.state.userData.cId
        );
        let ind = this.collection.indexOf(item);
        if (ind == -1) {
          this.collection.push(data);
        } else {
          this.collection[ind] = data;
        }
      }
      this.$store.commit("setSelection", this.collection);

      if (this.selectedIDs.length > 0) this.clear();
      this.iShow = true;

      this.isApproved = false;
      try {
        this.myObj.dtFrom = null;
        this.myObj.dtTo = null;

        if (this.isDatewise || this.reportDomain == "myskoolmerittoexcel") {
          if (this.settObj.rangeDate.indexOf(" to ") > -1) {
            var dt = this.settObj.rangeDate.split(" to ");
            this.myObj.dtFrom = dt[0];
            this.myObj.dtTo = dt[1];
          } else {
            if (this.settObj.rangeDate && this.settObj.rangeDate.length > 0) {
              var dt = this.settObj.rangeDate;
              this.myObj.dtFrom = dt;
              this.myObj.dtTo = dt;
            } else {
              this.myObj.dtFrom = null;
              this.myObj.dtTo = null;
            }
          }
        }

        if (
          this.reportDomain == "myskoolmerittoexcel" &&
          this.settObj.absentMarks &&
          this.settObj.absentMarks.length > 0
        ) {
          this.myObj.absentDeduction = parseInt(this.settObj.absentMarks) || 0;
        } else this.myObj.absentDeduction = 0;

        if (
          this.myObj.clsID > 0 &&
          ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
            this.reportDomain == "myskoolmakjauhar") &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        ) {
          this.LoadSubjectByClass();
          this.showGrid = true;
          this.gridLoading = true;
          let st = await this.runCreateResultInPhases(
            1,
            this.buildCreateResultPayload(this.myObj),
            { successMessage: this.$t("Result created") }
          );
          if (st === false) this.items = [];
          else this.items = st || [];

          if (this.publishLoadObj && this.publishLoadObj.valueBool) {
            let resPub = await this.get({
              url:
                this.$store.state.domain +
                "ResultPublished/LoadResultPublish?db=" +
                this.$store.state.userData.db +
                "&campusID=" +
                this.$store.state.userData.cId +
                "&classID=" +
                this.myObj.clsID +
                "&sectionID=" +
                this.myObj.sec +
                "&sessionID=" +
                this.myObj.sessionID +
                "&examID=" +
                this.myObj.examTypeID[0],
              token: this.$store.state.userData.token,
            });
            let pubList = [];
            if (resPub) {
              if (resPub.status == "success" && resPub.data) {
                pubList = resPub.data;
              } else if (Array.isArray(resPub)) {
                pubList = resPub;
              } else if (resPub.data && Array.isArray(resPub.data)) {
                pubList = resPub.data;
              }
            }

            if (pubList && pubList.length > 0) {
              this.publishData = pubList;
              this.selectedIDs = this.publishData
                .filter((el) => el.isPublished)
                .map((el) => el.sID);
            }
          }

          this.gridLoading = false;
          this.fetchStudentPictures();

          if (this.isEarlyYearReportClass()) {
            this.openEarlyYearReport();
          }
        } else {
          this.$bvToast.toast(
            this.$t("Please select all the required fields"),
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
      } finally {
        this.iShow = false;
      }
    },
    async fetchStudentPictures() {
      try {
        const res = await axios.get(
          this.$store.state.domain +
            "students/Filterdata?cls=" +
            this.myObj.clsID +
            "&sec=" +
            (this.myObj.sec || 0) +
            "&status=present&db=" +
            this.$store.state.userData.db +
            "&cId=" +
            this.$store.state.userData.cId +
            "&page=1",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.userData.token,
            },
          }
        );

        const studentList =
          (res.data &&
            res.data.data &&
            Array.isArray(res.data.data.data) &&
            res.data.data.data) ||
          (res.data && Array.isArray(res.data.data) && res.data.data) ||
          [];

        const newMap = {};
        studentList.forEach((s) => {
          newMap[String(s.id)] = s.picture || null;
        });

        this.pictureMap = Object.assign({}, newMap);
      } catch (e) {
        console.error("[pictures] fetch failed:", e);
      }
    },
    async ApplyDiscount() {
      this.myObj.campusID = this.$store.state.userData.cId;
      let data = {
        campusID: this.myObj.campusID,
        clsID: this.rewardObj.clsID,
        secID: this.rewardObj.secIDs,
        examID:
          this.myObj.examTypeID.length == 0 ? 0 : this.myObj.examTypeID[0],
        sessionID: this.myObj.sessionID,
      };

      this.iShow = true;
      try {
        this.myObj.dtFrom = null;
        this.myObj.dtTo = null;
        if (
          this.rewardObj.clsID > 0 &&
          this.rewardObj.secIDs > 0 &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        ) {
          this.gridLoading = true;
          this.items = await this.postObj({
            url:
              this.$store.state.domain +
              "Marks/UpdateFee?db=" +
              this.$store.state.userData.db,
            body: this.myObj,
            message: this.$t("Fee updated."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.showGrid = true;
          this.gridLoading = false;
        } else {
          this.$bvToast.toast(
            this.$t("Please select all the required fields"),
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
      } finally {
        this.iShow = false;
      }
    },
    setSelected(e, id) {
      if (e) {
        this.selectedIDs.push(id);
      } else {
        this.selectedIDs = this.selectedIDs.filter((el) => el != id);
      }
    },
    setSelectAll(e) {
      if (e) {
        this.selectedIDs = this.items.map((el) => el.sID);
      } else {
        this.selectedIDs = [];
      }
    },
    onRowSelect(ch) {
      if (ch) {
        if (this.selectedIDs.includes(ch.sID)) {
          this.selectedIDs = this.selectedIDs.filter((el) => el != ch.sID);
        } else {
          this.selectedIDs.push(ch.sID);
        }
      }
    },
    clear() {
      this.selectedIDs = [];
    },
    approveRes(val) {
      if (
        this.myObj.clsID > 0 &&
        ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
          this.reportDomain == "myskoolmakjauhar") &&
        this.myObj.sessionID > 0 &&
        this.myObj.examTypeID.length > 0
      ) {
        this.approving = true;
        setTimeout(() => {
          this.isApproved = val;
          this.approving = false;
          if (val) {
            this.$bvToast.toast(this.$t("Result is approved now."), {
              title: this.$t("Success!"),
              variant: "success",
              toaster: "b-toaster-top-right",
              solid: true,
            });
          } else {
            this.$bvToast.toast(this.$t("Approval removed successfully!"), {
              title: this.$t("Success!"),
              variant: "success",
              toaster: "b-toaster-top-right",
              solid: true,
            });
          }
        }, 2000);
      } else {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
    },
    checkPrint(val, reportWith = "") {
      if (this.approveObj && this.approveObj.valueBool) {
        if (this.isApproved) this.print(val, reportWith);
        else {
          this.$bvToast.toast(this.$t("Result is not approved yet"), {
            title: this.$t("Error!"),
            variant: "danger",
            toaster: "b-toaster-top-center",
          });
        }
      } else {
        this.print(val, reportWith);
      }
    },
    printSingle(sID, reportWith = "") {
      this.print(sID, reportWith);
    },
    getMonthName(month) {
      return months[month - 1];
    },
    async print(sID, reportWith = "") {
      if (this.isEarlyYearReportClass()) {
        const ids =
          sID !== "" && sID !== undefined && sID !== null
            ? String(sID)
            : this.selectedIDs.length
            ? this.selectedIDs.join(",")
            : "";
        this.openEarlyYearReport(ids);
        return;
      }

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      var myDate = "";
      if (
        this.reportDomain == "myskoolmerittoexcel" &&
        this.settObj.absentMarks &&
        this.settObj.absentMarks.length > 0
      ) {
        this.myObj.absentDeduction = parseInt(this.settObj.absentMarks) || 0;
      } else this.myObj.absentDeduction = 0;

      if (this.settObj.rangeDate.indexOf(" to ") > -1) {
        var dt = this.settObj.rangeDate.split(" to ");
        var dtFrom = dt[0].split("-");
        var dtTo = dt[1].split("-");
        this.myObj.dtFrom = dt[0];
        this.myObj.dtTo = dt[0];
        var mFrom = months[parseInt(dtFrom[1]) - 1];
        var mTo = months[parseInt(dtTo[1]) - 1];

        myDate = dtFrom[2] + "-" + mFrom + "-" + dtFrom[0];
        if (dtFrom != dtTo) {
          myDate += " to " + dtTo[2] + "-" + mTo + "-" + dtTo[0];
          this.myObj.dtTo = dt[1];
        }
      } else {
        if (
          this.settObj.rangeDate != undefined &&
          this.settObj.rangeDate != null &&
          this.settObj.rangeDate.length > 0
        ) {
          var dt = this.settObj.rangeDate;
          this.myObj.dtFrom = dt;
          this.myObj.dtTo = dt;
          var dtFrom = dt.split("-");
          var mFrom = months[parseInt(dtFrom[1]) - 1];
          myDate = dtFrom[2] + "-" + mFrom + "-" + dtFrom[0];
        } else {
          myDate = "";
          this.myObj.dtFrom = null;
          this.myObj.dtTo = null;
        }
      }
      this.examNames = [];
      this.myObj.examTypeID.forEach((el) => {
        let name = this.examType.find((elem) => elem.id == el).examType;
        if (name) this.examNames.push(name);
      });

      let clsName =
        this.classesOptions.find((elem) => elem.id == this.myObj.clsID)?.name ||
        "";

      this.current = sID;
      try {
        if (
          this.myObj.clsID > 0 &&
          ((this.reportDomain != "myskoolmakjauhar" && this.myObj.sec > 0) ||
            this.reportDomain == "myskoolmakjauhar") &&
          this.myObj.sessionID > 0 &&
          this.myObj.examTypeID.length > 0
        ) {
          this.iPrint = true;

          const sepPrintDt = this.settObj.printDate || "";

          const items = await this.runCreateResultInPhases(
            2,
            this.buildCreateResultPayload(this.myObj),
            { successMessage: this.$t("Result created") }
          );
          if (items === false) {
            this.iPrint = false;
            return;
          }
          this.items = items || [];
          this.showGrid = true;
          if (this.isFarabiReportDomain()) {
            this.openFarabiResult(sID);
            return;
          }
          const reportWithParam = reportWith ? `&reportWith=${reportWith}` : "";
          if (sID == "" && this.selectedIDs.length > 0) {
            let url = `https://${this.reportDomain}.myskool.app/Exams/Show?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.myObj.clsID}&sec=${this.myObj.sec}&examID=${this.myObj.examTypeID}&sessionID=${this.myObj.sessionID}&sIDs=${this.selectedIDs}&date=${myDate}&examType=${this.examNames}&clsName=${clsName}&resultDate=${sepPrintDt}${reportWithParam}`;
            window.open(url, "_blank");
          } else {
            let url = `https://${this.reportDomain}.myskool.app/Exams/Show?dbb=${this.$store.state.userData.db}&cID=${this.$store.state.userData.cId}&cls=${this.myObj.clsID}&sec=${this.myObj.sec}&examID=${this.myObj.examTypeID}&sessionID=${this.myObj.sessionID}&sIDs=${sID}&date=${myDate}&examType=${this.examNames}&clsName=${clsName}&resultDate=${sepPrintDt}${reportWithParam}`;
            window.open(url, "_blank");
          }
          this.iPrint = false;
        } else {
          this.$bvToast.toast(
            this.$t("Please select all the required fields"),
            {
              title: this.$t("Error!"),
              variant: "danger",
              toaster: "b-toaster-top-center",
            }
          );
        }
      } catch (error) {
        this.iPrint = false;
      } finally {
        this.iPrint = false;
      }
    },

    openMax() {
      this.visibility3 = true;
    },
    removeHeaderImg() {
      this.headerImageObj.value = null;
      this.imgLoading = false;
      this.$refs.headerImg.files = null;
    },
    async addHeaderImg() {
      let obj = this.$refs.headerImg.files[0];
      if (!obj) return;
      this.imgLoading = true;
      try {
        const uploaded = await uploadToMySkool([obj]);
        this.headerImageObj.value = getUploadPath(uploaded[0]);
      } catch (e) {
        console.log(e);
      } finally {
        this.imgLoading = false;
      }
    },
    removeFooterImg() {
      this.footerImageObj.value = null;
      this.footerImgLoading = false;
      this.$refs.footerImg.files = null;
    },
    async addFooterImg() {
      let obj = this.$refs.footerImg.files[0];
      if (!obj) return;
      this.footerImgLoading = true;
      try {
        const uploaded = await uploadToMySkool([obj]);
        this.footerImageObj.value = getUploadPath(uploaded[0]);
      } catch (e) {
        console.log(e);
      } finally {
        this.footerImgLoading = false;
      }
    },
    removeStamp() {
      this.stampObj.value = null;
      this.stLoading = false;
      this.$refs.stampImg.files = null;
    },
    async addStamp() {
      let obj = this.$refs.stampImg.files[0];
      if (!obj) return;
      this.stLoading = true;
      try {
        const uploaded = await uploadToMySkool([obj]);
        this.stampObj.value = getUploadPath(uploaded[0]);
      } catch (e) {
        console.log(e);
      } finally {
        this.stLoading = false;
      }
    },
    CheckTermDate() {
      if (this.termDate) {
        var elem = this.$refs["exam_date"];
        if (!this.termDate.value) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckStamp() {
      if (this.stampObj && this.stampObj.valueBool) {
        var elem = this.$refs["stamp"];
        if (!this.stampObj.value) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckCourse() {
      if (this.courseObj && this.courseObj.valueBool) {
        var elem = this.$refs["c_exam"];
        if (this.courseObj.valueNumber == 0) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    CheckExamTitle() {
      if (this.titleObj) {
        var elem = this.$refs["exam_title"];
        if (!this.titleObj.value) {
          return (elem.state = false);
        } else {
          return (elem.state = true);
        }
      } else return true;
    },
    async saveMax() {
      if (
        this.CheckTermDate() == true &&
        this.CheckStamp() == true &&
        this.CheckCourse() == true &&
        this.CheckExamTitle() == true
      ) {
        this.$store.commit("setResult", this.settObj);

        let data = [];
        if (this.lockObj && this.lockObj.valueBool) data.push(this.lockObj);
        if (this.termDate) data.push(this.termDate);
        if (this.logoObj) data.push(this.logoObj);
        if (this.headerObj) data.push(this.headerObj);
        if (this.footerObj) data.push(this.footerObj);
        if (this.stampObj) data.push(this.stampObj);
        if (this.promotedObj) data.push(this.promotedObj);
        if (this.courseObj) data.push(this.courseObj);
        if (this.titleObj) data.push(this.titleObj);
        if (this.formatObj) data.push(this.formatObj);
        if (this.headerImageObj) data.push(this.headerImageObj);
        if (this.footerImageObj) data.push(this.footerImageObj);
        data.push(this.buildResultPrintDateSetting());

        if (data.length > 0) {
          this.saving = true;
          var status = await this.post({
            url:
              this.$store.state.domain +
              "Settings/SaveNew?db=" +
              this.$store.state.userData.db +
              "&cID=" +
              this.$store.state.userData.cId,
            body: data,
            message: this.$t("Settings saved successfully."),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.saving = false;
          if (status) {
            this.loadSettings();
            this.visibility3 = false;
          }
        } else {
          this.visibility3 = false;
        }
      }
    },
    async openSettings() {
      this.rewardObj.clsID = this.myObj.clsID;
      this.FillRewardSec("filled");
      this.getFee();
      this.rewardObj.secIDs = null;
      if (this.myObj.sec > 0) this.rewardObj.secIDs = this.myObj.sec;

      this.visibility2 = true;
    },
    async getFee() {
      var obj = {
        url:
          this.$store.state.domain +
          "Students/LoadClassFee?clsID=" +
          this.myObj.clsID +
          "&campusId=" +
          this.$store.state.userData.cId +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.rewardObj.fee = await this.get(obj);
    },
    CheckNum() {
      var elem = this.$refs["fee"];
      var re = /^[0-9]+$/;
      if (re.test(this.rewardObj.fee) && this.rewardObj.fee != 0) {
        this.rewardObj.fee = parseInt(this.rewardObj.fee);
        return (elem.state = true);
      } else {
        return (elem.state = false);
      }
    },
    async saveSetting() {
      if (this.CheckNum() == true) {
        this.saving = true;
        this.saving = false;
      }
    },
    async Add() {
      this.CheckMarks();
      if (this.CheckMarks() == false) {
        return this.$bvToast.toast(this.$t("Please enter the marks."), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        if (this.marksObj.id == 0) {
          this.request = true;
          this.request = false;
          this.visibility = false;
        } else {
          this.request = true;
          this.request = false;
          this.visibility = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.result-job-modal__content {
  border: none;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 18px 45px rgba(115, 103, 240, 0.22);
}

.result-job-modal {
  padding: 1.5rem 1.25rem 1.35rem;
}

.result-job-modal__wrap {
  text-align: center;
}

.result-job-modal__loader {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 1rem;
  animation: result-job-pulse 2s ease-in-out infinite;
}

@keyframes result-job-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.03);
  }
}

.result-job-modal__ring {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.result-job-modal__ring-track,
.result-job-modal__ring-fill {
  fill: none;
  stroke-width: 8;
}

.result-job-modal__ring-track {
  stroke: #ece9ff;
}

.result-job-modal__ring-fill {
  stroke: #7367f0;
  stroke-linecap: round;
  stroke-dasharray: 326.73;
  transition: stroke-dashoffset 0.45s ease;
}

.result-job-modal__loader-center {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.result-job-modal__percent {
  font-size: 1.65rem;
  font-weight: 700;
  color: #7367f0;
}

.result-job-modal__percent-sign {
  font-size: 0.95rem;
  font-weight: 600;
  color: #9b92f0;
  margin-left: 1px;
  margin-top: 0.35rem;
}

.result-job-modal__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 0.35rem;
}

.result-job-modal__message {
  font-size: 0.9rem;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 0;
}

.result-job-modal__info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin-top: 1rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #eef9ff 0%, #e8f4ff 100%);
  border: 1px solid #b8e5ff;
  color: #027eb8;
  font-size: 0.82rem;
  font-weight: 500;
  line-height: 1.35;
  text-align: left;
}

.result-job-modal__bar-wrap {
  margin-top: 1.1rem;
  height: 6px;
  border-radius: 999px;
  background: #ece9ff;
  overflow: hidden;
}

.result-job-modal__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #9e95f5 0%, #7367f0 100%);
  transition: width 0.45s ease;
}
</style>
<style lang="scss" scoped>
.results-list-card {
  background: linear-gradient(180deg, #ffffff 0%, #faf9ff 100%);
  border: 1px solid #e0d8ff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(115, 103, 240, 0.12);
  overflow: visible;
  position: relative;
  transition: box-shadow 0.4s ease;

  &:hover {
    box-shadow: 0 15px 40px rgba(115, 103, 240, 0.2);
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 20px;
    right: 20px;
    height: 4px;
    border-radius: 0 0 4px 4px;
    background: linear-gradient(90deg, #7c5dfa 0%, #9d7aff 50%, #cbb9ff 100%);
    z-index: 10;
  }
}

.table-header {
  padding: 1.5rem 1.5rem 0.75rem;
}

.table-scroll-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 1rem 1rem;
  min-width: 0;
}

.filter-row {
  padding: 0.5rem 2rem 1.5rem;
}

.filter-control {
  border-radius: 12px !important;
  border: 1.5px solid #e2e8f0 !important;
  height: 50px !important;
  transition: all 0.3s ease;
  background-color: #f8fafc !important;

  &:focus {
    background-color: #fff !important;
    border-color: #7c5dfa !important;
    box-shadow: 0 0 0 4px rgba(124, 93, 250, 0.1) !important;
  }
}

.results-modern-table {
  border-collapse: separate !important;
  border-spacing: 0 12px !important;
  background-color: transparent !important;
  width: 100%;

  ::v-deep thead th {
    background: #f8fafc !important;
    border: none !important;
    border-bottom: 1px solid #e0d8ff !important;
    color: #5e50a3;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.75rem;
    padding: 1rem 1.25rem;
    letter-spacing: 0.05em;
    white-space: nowrap;
  }

  ::v-deep tbody tr {
    background: transparent;
    transition: all 0.2s ease;

    &:hover {
      background: #faf9ff;

      td {
        border-bottom: 1px solid #7c5dfa !important;
      }
    }

    td {
      background: transparent;
      border: none !important;
      border-bottom: 1px solid #e2e8f0 !important;
      padding: 1.25rem;
      vertical-align: middle;
      color: #334155;
      transition: all 0.2s ease;
    }
  }

  @media (min-width: 768px) {
    ::v-deep .sticky-sno,
    ::v-deep .sticky-name,
    ::v-deep .sticky-gr {
      position: sticky !important;
      background: #ffffff;
      z-index: 2;
    }

    ::v-deep th.sticky-sno,
    ::v-deep th.sticky-name,
    ::v-deep th.sticky-gr {
      position: sticky !important;
      z-index: 30 !important;
      background: #f8fafc !important;
    }

    ::v-deep .sticky-sno,
    ::v-deep th.sticky-sno {
      left: 0;
      min-width: 60px;
    }
    ::v-deep .sticky-gr,
    ::v-deep th.sticky-gr {
      left: 60px;
      min-width: 100px;
    }
    ::v-deep .sticky-name,
    ::v-deep th.sticky-name {
      left: 160px;
      min-width: 250px;
      border-right: none !important;
    }

    ::v-deep tbody tr:hover {
      .sticky-sno,
      .sticky-name,
      .sticky-gr {
        background: #faf9ff !important;
      }
    }
  }

  .metric-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.6rem;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 500;
    border: 1px solid transparent;

    &.marks-chip {
      background: #f0f4ff;
      color: #7c5dfa;
      border-color: #e0e7ff;
    }

    &.percentage-chip {
      background: #f5f3ff;
      color: #8b5cf6;
      border-color: #ede9fe;
    }

    &.grade-chip {
      background: #faf5ff;
      color: #a855f7;
      border-color: #f3e8ff;
    }

    &.rank-chip {
      &.rank-top {
        background: #f0fdf4;
        color: #16a34a;
        border-color: #dcfce7;
      }
      &.rank-normal {
        background: #f8fafc;
        color: #64748b;
        border-color: #f1f5f9;
      }
    }
  }

  .result-status-badge {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    padding: 0.6rem 1rem;
    font-size: 0.7rem;
    display: inline-flex;
    align-items: center;

    &.badge-light-success {
      background-color: #f0fdf4 !important;
      color: #16a34a !important;
    }
    &.badge-light-danger {
      background-color: #fef2f2 !important;
      color: #ef4444 !important;
    }
  }
}

.name-media {
  .avatar-shadow {
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }

  .name-content {
    display: flex;
    flex-direction: column;
    justify-content: center;

    .name-text {
      color: #0f172a;
      font-weight: 600;
      font-size: 0.95rem;
      margin-bottom: 2px;
    }
    .student-subtitle {
      font-size: 0.65rem;
      text-transform: uppercase;
      font-weight: 600;
      color: #64748b;
      letter-spacing: 0.05em;
      margin-bottom: 2px;
    }
    .father-name-text {
      font-size: 0.8rem;
      color: #475569;
    }
    .dues-text {
      font-size: 0.75rem;
      margin-top: 4px;
      padding: 2px 8px;
      background: #fef2f2;
      color: #ef4444;
      border-radius: 4px;
      display: inline-flex;
      align-items: center;
      width: max-content;
      font-weight: 600;
    }
  }
}

.print-action-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 14px !important;
  background: #ffffff !important;
  color: #7c5dfa !important;
  border: 1.5px solid #7c5dfa !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.25s ease !important;
  box-shadow: none !important;

  &:hover {
    background: #f3efff !important;
    box-shadow: 0 4px 12px rgba(124, 93, 250, 0.25) !important;
  }

  &:disabled {
    opacity: 0.5 !important;
  }
}

.skeleton-container {
  background: #fff;
}

.skeleton-row-item {
  padding: 1.5rem 0;
  border-bottom: 1px solid #f1f5f9;
  width: 100%;
}

.skeleton-item-wrapper {
  height: 54px;
  width: 100%;
}

.skeleton-line {
  background: #f1f5f9;
  position: relative;
  overflow: hidden;
}

.skeleton-line::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.2) 20%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* Filter Section Modernization */
.filter-group-custom label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #5e5873;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.filter-action-btn {
  border-radius: 12px !important;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  font-weight: 600;
  border: 1.5px solid transparent;
}

.btn-show-premium {
  background: linear-gradient(135deg, #7367f0 0%, #a067f0 100%) !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.3);
  padding: 0 20px;

  &:hover,
  &:focus,
  &:active {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(115, 103, 240, 0.4);
    background: linear-gradient(135deg, #8377f0 0%, #b077f0 100%) !important;
    color: #fff !important;
  }
}

.btn-action-outline-premium {
  background: #fff !important;
  border-color: #7367f0 !important;
  color: #7367f0 !important;
  width: 40px;
  padding: 0 !important;

  &:hover {
    background: #f8f7ff !important;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(115, 103, 240, 0.15);
  }

  &:active {
    transform: translateY(0);
  }
}

.filter-action-btn-dropdown {
  .btn.btn-action-outline-premium {
    width: auto !important;
    padding: 0 12px !important;
  }

  ::v-deep .dropdown-menu {
    z-index: 1050 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
    border-radius: 10px !important;
    border: 1px solid #e2e8f0 !important;
    min-width: 140px !important;
    background: #ffffff !important;
    padding: 6px 0 !important;

    .dropdown-item {
      padding: 8px 16px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #5e5873;
      display: flex;
      align-items: center;
      transition: all 0.2s ease;

      &:hover,
      &:focus {
        background-color: #f8f7ff;
        color: #7367f0;
      }
    }
  }
}

.clear-btn {
  width: 50px !important;
  height: 50px !important;
  border-radius: 12px !important;
  border: 1.5px solid #e2e8f0 !important;
  background: #f8fafc !important;
  color: #64748b !important;
  transition: all 0.3s ease;
  padding: 0 !important;

  &:hover {
    background: #fff !important;
    border-color: #7c5dfa !important;
    color: #7c5dfa !important;
  }
}

.stat-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: #fff;
  font-size: 0.82rem;
  white-space: nowrap;

  .stat-num {
    font-weight: 800;
    font-size: 0.95rem;
    color: #1e1b4b;
  }

  .stat-sep {
    color: #cbd5e1;
    font-size: 0.7rem;
  }

  .stat-label {
    text-transform: uppercase;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #64748b;
  }

  &.stat-passed .stat-num {
    color: #16a34a;
  }
  &.stat-failed .stat-num {
    color: #ef4444;
  }
  &.stat-grade .stat-num {
    color: #7c5dfa;
  }
}

/* Global Fix for Vue-Select Dropdowns in Sidebars/Modals */
.vs__dropdown-menu {
  z-index: 999999 !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
}

.vs__dropdown-option--highlight {
  background: #7367f0 !important;
  color: #fff !important;
}
</style>
